import React, { Component } from 'react'
import Select from 'react-select';
import { Link, Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import { connect } from 'react-redux';
import API_SETTINGS from '../../../api/apiSettings';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs'
import Collapsible from '../../../components/Collapsible/Collapsible'
import SearchInput from '../../../components/Input/SearchInput'
import ButtonDarkBlue from '../../../components/Button/ButtonDarkBlue';
import ButtonBorderDarkBlue from '../../../components/Button/ButtonBorderDarkBlue';
import chatBotOlaImage from '../../../assets/images/chatbot-ola.svg'
import IconDoubleCheck from '../../../assets/icons/IconDoubleCheck';
import ToggleSwitch from '../../../components/ToggleSwitch/ToggleSwitch';
import ChatBotFlowCard from '../../../components/Card/ChatBotFlowCard';
import LinkedInput from '../../../components/Input/LinkedInput';
import UnitInput from '../../../components/Input/UnitInput';
import { getContent, getErrorCode, getErrorMessage } from '../../../util/responseUtil';
import Alert from '../../../components/Alert/Alert';
import { CHATBOT_TYPE } from '../../../constants/menuChatBotFlowConstant';
import { v4 as uuidv4 } from 'uuid';
import LoadingLoader from '../../../components/LoadingLoader/LoadingLoader';
import NoChatPreviewImg from '../../../assets/images/NoChatPreview.svg'
import RouterPrompt from '../../../components/RouterPrompt/RouterPrompt';
import { CheckPermissionApi, CheckPermissionComponent } from '../../../util/permission';
import { SETTING_CHATBOT_FLOW_DELETE, SETTING_CHATBOT_FLOW_INSERT, SETTING_CHATBOT_FLOW_UPDATE, SETTING_CHATBOT_FLOW_VIEW } from '../../../constants/menuPermissionConstant';
import { chatBotCreateTicketUrl } from '../../../config/serviceConfig';

const TEMPLATE_GREETING = 'pesan-pembuka'
const TEMPLATE_SOLUTION = 'pesan-solusi'
const TEMPLATE_CLOSING = 'pesan-penutup'
const TEMPLATE_ERROR = 'pesan-eror'
const TEMPLATE_CREATE_TICKET = 'pesan-tiket'
const TEMPLATE_TIMEOUT = 'pesan-timeout'

const templates = [
    {
        id: "btngreetingmessage",
        title: 'Pesan Pembuka',
        template: TEMPLATE_GREETING
    },
    {
        id: "btnsolutionmessage",
        title: 'Pesan Solusi',
        template: TEMPLATE_SOLUTION
    },
    {
        id: "btnclosingmessage",
        title: 'Pesan Penutup',
        template: TEMPLATE_CLOSING
    },
    {
        id: "btnerrormessage",
        title: 'Pesan Eror',
        template: TEMPLATE_ERROR
    },
    {
        id: "btncreateticketmessage",
        title: 'Pesan Buat Tiket',
        template: TEMPLATE_CREATE_TICKET
    },
    {
        id: "btntimeoutmessage",
        title: 'Pesan Timeout',
        template: TEMPLATE_TIMEOUT
    }
]

class ChatBotFlow extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            showSuccessAlert: false,
            successAlertTitle: '',
            showErrorAlertResponse: false,
            errorMessage: '',
            newQNAName: '',
            qna: {
                page: 1,
                limit: 20,
                keyword: '',
                totalPage: 0,
                questionList: []
            },
            previewMessages: []
        }
    }

    componentDidMount() {
        this._isMounted = true
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setQNA = (state, callback) => {
        return this.setState({
            qna: state
        }, callback)
    }

    setNewQNAName = (value = '') => {
        this.setState({
            newQNAName: value
        })
    }

    setPreviewMessages = (messages = []) => {
        messages = messages.map(message => {
            message.key = uuidv4()
            message.answers = message?.answers?.map(answer => {
                answer.key = uuidv4()
                return answer
            }) || []

            return message
        })

        this.setState({
            previewMessages: [...messages]
        })
    }

    getListChatBotQuestion = (page = 1, keyword = '', replace = false) => {
        let filters = ''

        if (keyword) {
            filters += `question like ${keyword}`
        }

        return API_SETTINGS.getListChatBotQuestion(page, this.state.qna.limit, filters, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    const questions = getContent(res) || []
    
                    if (replace) {
                        const questionList = this.state.qna.questionList.slice(0, (page - 1) * this.state.qna.limit)
    
                        this.setState({
                            qna: {
                                ...this.state.qna,
                                questionList: [...questionList, ...questions]
                            }
                        })
    
                        return
                    }
    
                    this.setState({
                        qna: {
                            ...this.state.qna,
                            questionList: questions
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    loadNewChatBotQuestion = (page = 1, keyword = '') => {
        let filters = ''

        if (keyword) {
            filters += `question like ${keyword}`
        }

        return API_SETTINGS.getListChatBotQuestion(page, this.state.qna.limit, filters, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    const questions = getContent(res) || []
    
                    this.setState({
                        qna: {
                            ...this.state.qna,
                            questionList: [...this.state.qna.questionList, ...questions]
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    initiateGetListChatBotQuestion = (keyword = '') => {
        let filters = ''

        if (keyword) {
            filters += `question like ${keyword}`
        }

        return API_SETTINGS.initiateGetListChatBotQuestion(filters, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    const content = getContent(res)
                    const countData = content?.count_data || 0
    
                    this.setState({
                        qna: {
                            ...this.state.qna,
                            totalPage: Math.ceil(countData / this.state.qna.limit)
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    clearPreviewMessages = () => {
        this.setState({
            previewMessages: []
        })
    }

    showSuccessAlert = (title) => {
        this.setState({
            showSuccessAlert: true,
            successAlertTitle: title ? title : 'Data berhasil disimpan!'
        })

        setTimeout(() => {
            this.setState({
                showSuccessAlert: false,
                successAlertTitle: ''
            })
        }, 1500)
    }

    showErrorAlert = (errorMessage = '') => {
        this.setState({
            showErrorAlertResponse: true,
            errorMessage
        })
    }

    showLoader = (isLoading = false) => {
        this.setState({ isLoading })
    }

    isCreate = () => {
        const searchParams = new URLSearchParams(document.location.search)

        return searchParams.get("create") === "true"
    }

    render() {
        return (
            <>
                <LoadingLoader show={this.state.isLoading} />
                <div className="pb-8">
                    <div className="space-y-3 h-breadcrumb mb-5">
                        {/* BREADCRUMBS */}
                        <BreadCrumbs
                            parentMenu="Pengaturan"
                            serviceMenu="Flow Chatbot"
                            title="Flow Chatbot"
                        />
                    </div>
                    <div style={{ height: '90vh' }}>
                        <div className="flex justify-between items-start gap-2 h-full">
                            <CheckPermissionComponent permissionConstant={[SETTING_CHATBOT_FLOW_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <ChatBotMessageTemplate
                                    qna={this.state.qna}
                                    setQNA={this.setQNA}
                                    showSuccessAlert={this.showSuccessAlert}
                                    showErrorAlert={this.showErrorAlert}
                                    showLoader={this.showLoader}
                                    getListChatBotQuestion={this.getListChatBotQuestion}
                                    loadNewChatBotQuestion={this.loadNewChatBotQuestion}
                                    initiateGetListChatBotQuestion={this.initiateGetListChatBotQuestion}
                                    isCreate={this.isCreate()}
                                    newQNAName={this.state.newQNAName}
                                    {...this.props}
                                />
                                <ChatBotFlowForm
                                    qna={this.state.qna}
                                    setQNA={this.setQNA}
                                    showSuccessAlert={this.showSuccessAlert}
                                    showErrorAlert={this.showErrorAlert}
                                    showLoader={this.showLoader}
                                    setNewQNAName={this.setNewQNAName}
                                    setPreviewMessages={this.setPreviewMessages}
                                    clearPreviewMessages={this.clearPreviewMessages}
                                    getListChatBotQuestion={this.getListChatBotQuestion}
                                    loadNewChatBotQuestion={this.loadNewChatBotQuestion}
                                    initiateGetListChatBotQuestion={this.initiateGetListChatBotQuestion}
                                    {...this.props}
                                />
                                <ChatBotPreview previewMessages={this.state.previewMessages} />
                            </CheckPermissionComponent>
                        </div>
                    </div>
                </div>
                <Alert
                    show={this.state.showSuccessAlert}
                    icon="success"
                    title={this.state.successAlertTitle}
                />
                <Alert
                    show={this.state.showErrorAlertResponse}
                    icon="warning"
                    title={this.state.errorMessage}
                    close={() => this.setState({ showErrorAlertResponse: false })}
                    ok
                />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatBotFlow);

class ChatBotMessageTemplate extends Component {
    constructor(props) {
        super(props)

        this.qnaObserver = null
        this.qnaListRef = React.createRef()
        this.defaultLimit = 20
        this.state = {
            redirectTo: null,
            page: 1,
            limit: this.defaultLimit,
            keyword: '',
            totalPage: 0,
            confirmAlert: {
                showConfirmAlert: false,
                onSubmit: null
            }
        }
    }

    async componentDidMount() {
        this._isMounted = true

        await this.props.getListChatBotQuestion()

        await this.props.initiateGetListChatBotQuestion()

        this.observeLastQNA()

        /*
            Scroll to bottom
        */
        if (this.props.isCreate) {
            this.qnaListRef.current.scrollTop = this.qnaListRef.current.scrollHeight
        }
    }

    componentWillUnmount() {
        this._isMounted = false

        if (this.qnaObserver) {
            this.qnaObserver?.disconnect()
        }
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.isCreate !== this.props.isCreate && this._isMounted) {
            /*
                Scroll to bottom
            */
            if (this.props.isCreate) {
                this.qnaListRef.current.scrollTop = this.qnaListRef.current.scrollHeight
            }

            /*
                Reobserve Last QNA
            */
            this.observeLastQNA()
        }
    }

    isCreate = () => {
        const searchParam = new URLSearchParams(document.location.search)

        return searchParam.get("create") === "true"
    }

    setKeyword = (e) => {
        this.props.setQNA({
            ...this.props.qna,
            keyword: e.target.value
        })
    }

    searchQNA = async (e) => {
        e.preventDefault()

        this.props.setQNA({
            ...this.props.qna,
            page: 1,
        })

        await this.props.getListChatBotQuestion(1, this.props.qna.keyword)
        await this.props.initiateGetListChatBotQuestion(this.props.qna.keyword)

        this.observeLastQNA()

        this.qnaListRef.current.scrollTop = 0
    }

    showConfirmAlert = (onSubmit) => {
        return this.setState({
            confirmAlert: {
                ...this.state.confirmAlert,
                showConfirmAlert: true,
                onSubmit
            }
        })
    }

    closeConfirmAlert = () => {
        return this.setState({
            confirmAlert: {
                showConfirmAlert: false,
                onSubmit: null
            }
        })
    }

    observeLastQNA = () => {
        const lastQNA = this.qnaListRef.current.children[this.qnaListRef.current.children.length - 1]

        if (!lastQNA) {
            return
        }

        if (this.qnaObserver) {
            this.qnaObserver.disconnect()
        }

        this.qnaObserver = new IntersectionObserver(async entries => {
            const lastQNA = entries[0]

            if (!entries[0].isIntersecting) {
                return
            }

            if (this.props.qna.page !== this.props.qna.totalPage && !this.isCreate()) {
                const newPage = this.props.qna.page + 1

                await this.props.loadNewChatBotQuestion(newPage, this.props.qna.keyword)

                this.props.setQNA({
                    ...this.props.qna,
                    page: newPage
                })

                this.qnaObserver.observe(this.qnaListRef.current.children[this.qnaListRef.current.children.length - 1])
            }

            this.qnaObserver.unobserve(lastQNA.target)
        }, {
            threshold: 0.5
        })

        this.qnaObserver.observe(lastQNA)
    }

    mapTemplates = () => {
        const searchParams = new URLSearchParams(document.location.search)
        const templateParam = searchParams.get('template')

        return templates.map((template, i) => {
            const activeClass = templateParam === template.template ? 'font-bold text-white bg-white-3' : 'text-secondary-text hover:bg-lightbluegrey'

            return (
                <Link
                    key={i}
                    to={`?template=${template.template}`}
                    id={template.id}
                    className={`block bg-white p-4 border-l-8 border-olddarkblue rounded-md mb-3 shadow-md transition duration-200 select-none ${activeClass}`}
                >
                    {template.title}
                </Link>
            )
        })
    }

    mapQNA() {
        const searchParams = new URLSearchParams(document.location.search)
        const qnaId = parseInt(searchParams.get('qnaid')) || 0

        return this.props.qna.questionList.map(question => {
            let qnaActiveClass = 'text-secondary-text bg-white hover:bg-lightbluegrey';
            let closeIconActiveClass = 'border-secondary-text'

            if (qnaId === question.id) {
                qnaActiveClass = 'text-white bg-white-3'
                closeIconActiveClass = 'border-white'
            }

            return (
                <Link
                    to={`?qnaid=${question.id}`}
                    key={question.id}
                    className={`flex justify-between items-center p-4 border-l-8 border-limegreen rounded-md mb-3 shadow-md transition w-full duration-200 ${qnaActiveClass}`}
                    title={question.question}
                >
                    <span className="block truncate">{question.question}</span>
                    <CheckPermissionComponent
                        permissionConstant={[SETTING_CHATBOT_FLOW_DELETE]}
                        userPermission={this.props.userDetail.permissions}
                    >
                        <div
                            className="btndelete ml-3"
                            onClick={(e) => this.handleDeleteQNA(e, question)}
                        >
                            <FontAwesomeIcon
                                className={`border-2 rounded-full w-3 h-3 p-0.5 cursor-pointer ${closeIconActiveClass}`}
                                icon={faClose}
                            />
                        </div>
                    </CheckPermissionComponent>
                </Link>
            )
        })
    }

    showCreateNewQNA = () => {
        const searchParams = new URLSearchParams(document.location.search)

        if (searchParams.get("create") !== "true") {
            return
        }

        return (
            <form
                className={`flex justify-between items-center p-4 border-l-8 border-limegreen rounded-md mb-3 shadow-md transition duration-200 text-secondary-text bg-white`}
            >
                <input className="font-bold outline-none w-full text-base" placeholder='' />
            </form>
        )
    }

    handleDeleteQNA = (e, question) => {
        e.preventDefault()

        this.showConfirmAlert(() => {
            this.handleRequestDeleteQNA(question)
        })
    }

    handleRequestDeleteQNA = async (question) => {
        this.props.showLoader(true)

        const res = await this.deleteChatBotQNA(question.id, question.updated_at)

        if (res.status !== 200) {
            this.props.showLoader(false)
            this.closeConfirmAlert()

            return
        }

        this.props.showLoader(false)

        this.closeConfirmAlert()

        this.props.showSuccessAlert('Data berhasil dihapus!')

        await this.props.initiateGetListChatBotQuestion(this.props.keyword)

        this.handleRedirect(question)

        const questionList = this.props.qna.questionList.filter(q => q.id !== question.id)

        this.props.setQNA({
            ...this.props.qna,
            questionList: [...questionList]
        })
    }

    deleteChatBotQNA = (id, updatedAt) => {
        return API_SETTINGS.deleteChatBotQNA(id, { updated_at: updatedAt }, this.props.token)
            .catch(err => {
                this.props.showErrorAlert(getErrorMessage(err))
                return err
            })
    }

    handleRedirect = async (question) => {
        const searchParam = new URLSearchParams(document.location.search)
        const activeQNAId = parseInt(searchParam.get("qnaid")) || 0

        if (!activeQNAId) {
            return
        }

        if (activeQNAId !== question.id) {
            return
        }

        const i = this.props.qna.questionList.findIndex(qna => qna.id === question.id)
        if (i === -1) {
            return
        }

        /*
            Next Data
        */
        let showData = this.props.qna.questionList[i + 1]
        if (showData) {
            this.props.history.push(`?qnaid=${showData.id}`)
            return
        }

        /*
            Previous Data
        */
        showData = this.props.qna.questionList[i - 1]
        if (showData) {
            this.props.history.push(`?qnaid=${showData.id}`)
            return
        }

        this.props.history.push(`${ROUTER_CONSTANT.SETTINGS_CHATBOT_FLOW}?template=${TEMPLATE_GREETING}`)
    }

    renderNewQNACard = () => {
        if (!CheckPermissionApi(SETTING_CHATBOT_FLOW_INSERT, this.props.userDetail.permissions)) {
            return null
        }

        if (!this.props.isCreate) {
            return null
        }

        return (
            <div
                className={`flex justify-between items-center p-4 border-l-8 border-limegreen rounded-md mb-3 shadow-md transition duration-200 bg-white`}
            >
                <span
                    className={`truncate ${this.props.newQNAName ? 'font-bold text-secondary-text' : 'text-gray-400'} select-none`}
                >
                    {this.props.newQNAName ? this.props.newQNAName : 'Tulis Judul Tanya & Jawab'}
                </span>
            </div>
        )
    }

    render() {
        if (this.state.redirectTo) {
            return this.state.redirectTo
        }

        return (
            <>
                <Alert
                    title="Hapus Tanya & Jawab"
                    desc="Apakah Anda yakin ingin menghapus data?"
                    show={this.state.confirmAlert.showConfirmAlert}
                    button
                    buttonOKText="Ya, Hapus"
                    buttonCancelText="Batal"
                    maxContentButtons
                    close={this.closeConfirmAlert}
                    submit={this.state.confirmAlert.onSubmit}
                />

                <div className="message-template flex flex-col py-4 bg-white shadow-md rounded-md border border-gray-300 w-1/4 h-full" id="messageTemplate">
                    <h5 className="text-2xl font-medium mb-3 px-4">Pilih Template Pesan Otomatis</h5>
                    <div className="w-full h-full max-h-full overflow-auto px-4">
                        <Collapsible
                            className="mb-3"
                            title="Template Pesan"
                            subTitle="Silahkan memilih kategori untuk sistem pesan chatbot."
                            defaultOpen={true}
                        >
                            {this.mapTemplates()}
                        </Collapsible>
                        <Collapsible
                            title="Tanya & Jawab"
                            subTitle="Pengaturan pertanyaan dan jawaban"
                            defaultOpen={true}
                            maxHeight={500}
                        >
                            <SearchInput
                                className="mb-3"
                                inputClassName="tslsearch"
                                placeholder="Cari Tanya & Jawab"
                                value={this.state.keyword}
                                onChange={this.setKeyword}
                                onSubmit={this.searchQNA}
                                canSubmit={true}
                                style={{ 
                                    marginTop: '2px', 
                                    marginLeft: '2px',
                                    marginRight: '2px'
                                }}
                            />
                            <div className="mb-3 overflow-auto relative" style={{ maxHeight: '350px' }} ref={this.qnaListRef}>
                                {this.mapQNA()}

                                {/* 
                                    Create new QNA
                                */}
                                {this.renderNewQNACard()}
                            </div>
                            <CheckPermissionComponent permissionConstant={[SETTING_CHATBOT_FLOW_INSERT]} userPermission={this.props.userDetail.permissions}>
                                <Link to="?create=true">
                                    <ButtonBorderDarkBlue
                                        className="btnaddqna w-full"
                                        type="button"
                                        style={{ backgroundColor: 'transparent' }}
                                    >
                                        <FontAwesomeIcon size="sm" className="mr-1" icon={faPlusCircle} />
                                        <span>Tambah</span>
                                    </ButtonBorderDarkBlue>
                                </Link>
                            </CheckPermissionComponent>
                        </Collapsible>
                    </div>
                </div>
            </>
        )
    }
}

class ChatBotFlowForm extends Component {
    constructor(props) {
        super(props)

        this.defaultRelatedAnswer = {
            label: 'Pilih Jawaban',
            value: 0
        }

        this.state = {
            errorAnswers: [],
            relatedAnswerOptions: [],
            currentRelatedAnswers: [],
            isQNAFound: true,
            resetFormAlert: {
                show: false,
                handler: null
            },
            data: {
                automaticMessage: '',
                backOption: false,
                relatedAnswers: [],
                removedRelatedAnswers: [],
                answerList: [],
                chatTimeout: '',
                closingDuration: '',
                parameters: [],
                isFirstMessage: false,
                isRelatedToSolution: false,
                kmsId: 0,
                qnaName: '',
                kms: null
            }
        }
    }

    clearState = () => {
        return this.setState({
            errorAnswers: [],
            relatedAnswerOptions: [],
            currentRelatedAnswers: [],
            isQNAFound: true,
            isCreate: false,
            data: {
                automaticMessage: '',
                backOption: false,
                relatedAnswers: [],
                removedRelatedAnswers: [],
                answerList: [],
                chatTimeout: 0,
                closingDuration: 0,
                parameters: [],
                isFirstMessage: false,
                isRelatedToSolution: false,
                kmsId: 0,
                qnaName: '',
                kms: null
            }
        })
    }

    componentDidUpdate(_, prevState) {
        if (prevState.data.qnaName !== this.state.data.qnaName) {
            this.props.setNewQNAName(this.state.data.qnaName)
        }
    }

    getDetailChatBotByType = (chatBotType) => {
        return API_SETTINGS.getDetailChatBotByType(chatBotType, this.props.token)
            .catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getChatBotRelatedAnswers = (page = 1, limit = 100, type = 'default-message', key, keyword = '') => {
        return API_SETTINGS.getChatBotAnswers(page, limit, type, key, keyword, this.props.token)
            .catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    setDefaultState = (state, callback) => {
        return this.setState(state, callback)
    }

    setErrorAnswers = (errorAnswers, callback) => {
        return this.setState({
            errorAnswers
        }, callback)
    }

    setIsQNAFound = (isFound, callback) => {
        return this.setState({
            isQNAFound: isFound
        }, callback)
    }

    showResetFormAlert = (onSubmit) => {
        return this.setState({
            resetFormAlert: {
                show: true,
                handler: onSubmit
            }
        })
    }

    closeResetFormAlert = () => {
        return this.setState({
            resetFormAlert: {
                show: false,
                handler: null
            }
        })
    }

    handleChange = e => {
        return this.setState({
            data: {
                ...this.state.data,
                [e.target.name]: e.target.value
            }
        })
    }

    handleChangeNumberOnly = e => {
        const re = /^[0-9]+$/;

        if (e.target.value === '' || re.test(e.target.value)) {
            return this.setState({
                data: {
                    ...this.state.data,
                    [e.target.name]: e.target.value
                }
            })
        }
    }

    handleChecked = e => {
        return this.setState({
            data: {
                ...this.state.data,
                [e.target.name]: e.target.checked
            }
        })
    }

    handleAddAnswer = async (callback) => {
        const tempData = this.state.data

        tempData.answerList.push({
            key: uuidv4(),
            id: 0,
            answer: '',
            url_link: '',
            action: 'insert',
            withLink: false
        })

        await this.setState({
            data: {
                ...tempData,
            }
        })

        if (callback) {
            callback()
        }
    }

    handleAnswerValueChange = (e, key) => {
        const tempData = this.state.data
        const idx = this.state.data.answerList.findIndex(answer => answer.key === key)

        if (idx === -1) {
            return
        }

        tempData.answerList[idx].answer = e.target.value

        this.setState({
            data: {
                ...tempData,
            }
        })
    }

    handleRemoveAnswer = (key) => {
        const tempData = this.state.data
        const idx = this.state.data.answerList.findIndex(answer => answer.key === key)

        if (idx === -1) {
            return
        }

        const answer = tempData.answerList[idx]

        if (answer.action === 'update') {
            tempData.answerList[idx].action = 'delete'

            this.setState({
                data: {
                    ...tempData
                }
            })

            return
        }

        tempData.answerList = tempData.answerList.filter(answer => answer.key !== key)

        this.setState({
            data: {
                ...tempData
            }
        })
    }

    handleAddLink = key => {
        const tempData = this.state.data
        const idx = this.state.data.answerList.findIndex(answer => answer.key === key)

        if (idx === -1) {
            return
        }

        tempData.answerList[idx].withLink = true

        this.setState({
            data: {
                ...tempData,
            }
        })
    }

    handleAnswerLinkValueChange = (e, key) => {
        const tempData = this.state.data
        const idx = this.state.data.answerList.findIndex(answer => answer.key === key)

        if (idx === -1) {
            return
        }

        tempData.answerList[idx].url_link = e.target.value

        this.setState({
            data: {
                ...tempData,
            }
        })
    }

    handleRemoveLink = (key) => {
        const tempData = this.state.data
        const idx = this.state.data.answerList.findIndex(answer => answer.key === key)

        if (idx === -1) {
            return
        }

        tempData.answerList[idx].url_link = ''
        tempData.answerList[idx].withLink = false

        this.setState({
            data: {
                ...tempData,
            }
        })
    }

    handleSearchRelatedAnswer = (value, type, key) => {
        this.getChatBotRelatedAnswers(1, 100, type, key, value, this.props.token)
            .then((res) => {
                const content = getContent(res) || []
                let relatedAnswers = []

                for (const relatedAnswer of content) {
                    const selectedRelatedAnswer = this.state.data.relatedAnswers.find(item => item.id === relatedAnswer.id)
                    if (selectedRelatedAnswer) {
                        continue
                    }

                    relatedAnswers.push({
                        label: relatedAnswer.answer,
                        value: relatedAnswer.id
                    })
                }

                relatedAnswers = [
                    ...relatedAnswers,
                    ...this.state.data.removedRelatedAnswers.map(item => ({
                        label: item.answer,
                        value: item.id
                    }))
                ]

                this.setState({
                    relatedAnswerOptions: relatedAnswers
                })
            })
    }

    handleRelatedAnswerChange = async (option, relatedAnswerListRef) => {
        if (option.value === this.defaultRelatedAnswer.value) {
            return
        }

        let action = 'insert'
        const tempData = this.state.relatedAnswerOptions.filter(answer => answer.value !== option.value)
        const removedRelatedAnswers = this.state.data.removedRelatedAnswers.filter(answer => answer.id !== option.value)
        const currentAnswerIdx = this.state.currentRelatedAnswers.findIndex(answer => answer.id === option.value)

        if (currentAnswerIdx > -1) {
            action = 'update'
        }

        await this.setState({
            relatedAnswerOptions: [...tempData],
            data: {
                ...this.state.data,
                relatedAnswers: [
                    ...this.state.data.relatedAnswers,
                    {
                        id: option.value,
                        answer: option.label,
                        action: action
                    }
                ],
                removedRelatedAnswers: [...removedRelatedAnswers]
            }
        })

        if (relatedAnswerListRef) {
            relatedAnswerListRef.current.scrollTop = relatedAnswerListRef.current.scrollHeight
        }
    }

    handleRemoveRelatedAnswer = (answer) => {
        const relatedAnswers = this.state.data.relatedAnswers.filter(selectedAnswer => selectedAnswer.id !== answer.id)
        const relatedAnswerOptions = [...this.state.relatedAnswerOptions, {
            label: answer.answer,
            value: answer.id
        }]

        relatedAnswerOptions.sort((a, b) => a.value - b.value)

        let removedRelatedAnswers = this.state.data.removedRelatedAnswers
        let currentAnswerIdx = this.state.currentRelatedAnswers.findIndex(currentAnswer => currentAnswer.id === answer.id)

        if (currentAnswerIdx > -1) {
            removedRelatedAnswers = [
                ...removedRelatedAnswers,
                {
                    id: answer.id,
                    answer: answer.answer,
                    action: 'delete'
                }
            ]
        }

        this.setState({
            data: {
                ...this.state.data,
                relatedAnswers: [...relatedAnswers],
                removedRelatedAnswers
            },
            relatedAnswerOptions: [...relatedAnswerOptions]
        })
    }

    clearRemovedRelatedAnswers = () => {
        return this.setState({
            data: {
                ...this.state.data,
                removedRelatedAnswers: []
            }
        })
    }

    validateAutomaticMessage = (automaticMessage) => {
        if (automaticMessage.length < 10) {
            return 'Minimal panjang karakter Pesan Otomatis 10 karakter'
        }

        if (automaticMessage.length > 300) {
            return 'Maksimal panjang karakter Pesan Otomatis 300 karakter'
        }

        return ''
    }

    validateAnswers = (answers) => {
        const errorAnswers = []

        for (let i = 0; i < answers.length; i++) {
            const answer = answers[i]
            const errorAnswer = {
                index: i,
                inputError: '',
                linkError: ''
            }

            const answerErrorMessage = this.validateAnswer(answer.answer)
            if (answerErrorMessage !== '') {
                errorAnswer.inputError = answerErrorMessage
                errorAnswers.push(errorAnswer)
            }

            if (!answer.withLink) {
                continue
            }

            const linkErrorMessage = this.validateLink(answer.url_link)
            if (linkErrorMessage !== '') {
                errorAnswer.linkError = linkErrorMessage
                errorAnswers.push(errorAnswer)
            }
        }

        return errorAnswers
    }

    validateAnswer = (answer) => {
        if (answer.length < 3) {
            return 'Minimal 3 karakter'
        }

        if (answer.length > 100) {
            return 'Maksimal 100 karakter'
        }

        return ''
    }

    validateLink = (link) => {
        const linkRegExp = /^https?:\/\/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)$/g

        if (link === '') {
            return 'Link URL tidak boleh kosong'
        }

        if (!linkRegExp.test(link)) {
            return 'Format Link URL salah'
        }

        return ''
    }

    getAddProps = () => ({
        data: this.state.data,
        errorAnswers: this.state.errorAnswers,
        defaultRelatedAnswer: this.defaultRelatedAnswer,
        currentRelatedAnswers: this.state.currentRelatedAnswers,
        relatedAnswerOptions: this.state.relatedAnswerOptions,
        isQNAFound: this.state.isQNAFound,
        getDetailChatBotByType: this.getDetailChatBotByType,
        getChatBotRelatedAnswers: this.getChatBotRelatedAnswers,

        /*
            State setter
        */
        setDefaultState: this.setDefaultState,
        setErrorAnswers: this.setErrorAnswers,
        setIsQNAFound: this.setIsQNAFound,
        clearState: this.clearState,

        /*
            Reset Form Alert
        */
        showResetFormAlert: this.showResetFormAlert,
        closeResetFormAlert: this.closeResetFormAlert,

        /* 
            Input Change
        */
        handleChange: this.handleChange,
        handleChangeNumberOnly: this.handleChangeNumberOnly,

        /* 
            Checkbox Change
        */
        handleChecked: this.handleChecked,

        /* 
            Answer Input
        */
        handleAddAnswer: this.handleAddAnswer,
        handleAnswerValueChange: this.handleAnswerValueChange,
        handleRemoveAnswer: this.handleRemoveAnswer,
        handleAddLink: this.handleAddLink,
        handleAnswerLinkValueChange: this.handleAnswerLinkValueChange,
        handleRemoveLink: this.handleRemoveLink,

        /*
            Related Answer Select
        */
        handleSearchRelatedAnswer: this.handleSearchRelatedAnswer,
        handleRelatedAnswerChange: this.handleRelatedAnswerChange,
        handleRemoveRelatedAnswer: this.handleRemoveRelatedAnswer,
        clearRemovedRelatedAnswers: this.clearRemovedRelatedAnswers,

        /*
            Validations
        */
        validateAutomaticMessage: this.validateAutomaticMessage,
        validateAnswers: this.validateAnswers,
    })

    switchForm = () => {
        const searchParams = new URLSearchParams(document.location.search)

        const addProps = this.getAddProps()

        switch (searchParams.get('template')) {
            case TEMPLATE_GREETING:
                return <ChatBotGreetingForm {...this.props} {...addProps} />
            case TEMPLATE_SOLUTION:
                return <ChatBotSolutionForm {...this.props} {...addProps} />
            case TEMPLATE_CLOSING:
                return <ChatBotClosingForm {...this.props} {...addProps} />
            case TEMPLATE_ERROR:
                return <ChatBotErrorForm {...this.props} {...addProps} />
            case TEMPLATE_CREATE_TICKET:
                return <ChatBotCreateTicketForm {...this.props} {...addProps} />
            case TEMPLATE_TIMEOUT:
                return <ChatBotTimeoutForm {...this.props} {...addProps} />
            default:
                return <ChatBotQuestionAndAnswerForm
                    qnaId={parseInt(searchParams.get('qnaid')) || 0}
                    isCreate={searchParams.get('create') === "true"}
                    {...this.props}
                    {...addProps}
                />
        }
    }

    render() {
        return (
            <>
                <Alert
                    show={this.state.resetFormAlert.show}
                    title="Atur Ulang"
                    desc="Anda yakin ingin membatalkan perubahan?"
                    button
                    close={this.closeResetFormAlert}
                    submit={this.state.resetFormAlert.handler || undefined}
                />
                {this.switchForm()}
            </>
        )
    }
}

class ChatBotGreetingForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentChatBotMessage: null,
            isFormDirty: false
        }
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.data !== this.props.data) {
            this.setIsFormDirty()
        }
    }

    async componentDidMount() {
        this.props.clearState()

        this.props.showLoader(true)

        await this.getDetailChatBotGreeting()

        this.props.showLoader(false)
    }

    getDetailChatBotGreeting = () => {
        return this.props.getDetailChatBotByType(CHATBOT_TYPE.typeGreeting)
            .then(res => {
                const data = getContent(res)

                this.props.setPreviewMessages([
                    {
                        isBot: true,
                        message: data.bot_message,
                    }
                ])

                this.props.setDefaultState({
                    data: {
                        ...this.props.data,
                        automaticMessage: data.bot_message
                    }
                })

                this.setState({
                    currentChatBotMessage: data
                })
            })
    }

    setIsFormDirty = () => {
        const { currentChatBotMessage } = this.state

        if (!currentChatBotMessage) {
            return
        }

        if (currentChatBotMessage.bot_message !== this.props.data.automaticMessage) {
            return this.setState({
                isFormDirty: true
            })
        }

        return this.setState({
            isFormDirty: false
        })
    }

    handleSubmit = e => {
        e.preventDefault()

        if (!CheckPermissionApi(SETTING_CHATBOT_FLOW_UPDATE, this.props.userDetail.permissions)) {
            return
        }

        this.props.showLoader(true)

        if (!this.validateData()) {
            this.props.showLoader(false)
            return
        }

        const data = {
            bot_message: this.props.data.automaticMessage
        }

        API_SETTINGS.postChatBotGreeting(data, this.props.token)
            .then(async () => {
                this.props.showSuccessAlert()

                await this.getDetailChatBotGreeting()

                this.setIsFormDirty()

                this.props.showLoader(false)
            })
            .catch(err => this.props.showErrorAlert(getErrorMessage(err)))
            .finally(() => this.props.showLoader(false))
    }

    validateData = () => {
        const data = this.props.data

        if (data.automaticMessage.length < 10) {
            this.props.showErrorAlert('Minimal panjang karakter Pesan Otomatis 10 karakter')

            return false
        }

        if (data.automaticMessage.length > 300) {
            this.props.showErrorAlert('Maksimal panjang karakter Pesan Otomatis 300 karakter')

            return false
        }

        return true
    }

    resetForm = () => {
        const data = this.state.currentChatBotMessage

        this.props.setDefaultState({
            data: {
                ...this.props.data,
                automaticMessage: data.bot_message
            }
        }, () => this.props.closeResetFormAlert())
    }

    render() {
        return (
            <>
                <RouterPrompt
                    when={this.state.isFormDirty}
                    history={this.props.history}
                />
                <form className="chatbot-flow-form flex flex-col w-2/4 h-full p-6 bg-white shadow-md rounded-md border border-gray-300 overflow-auto" onSubmit={this.handleSubmit}>
                    <div className="mb-10">
                        <h6 className="text-xl font-bold mb-8">Pesan Pembuka</h6>
                        <ChatBotFlowCard
                            title="Pesan Otomatis"
                            cardBodyStyles={{
                                height: '400px',
                                maxHeight: '500px'
                            }}>
                            <div>
                                <label className="inline-block font-medium mb-1" htmlFor="tmlbotmessage">Pesan Otomatis</label>
                                <textarea
                                    className="resize-none form-control"
                                    id="tmlbotmessage"
                                    cols="30"
                                    rows="8"
                                    placeholder='Tulis Pesan Otomatis'
                                    value={this.props.data.automaticMessage}
                                    name="automaticMessage"
                                    onChange={this.props.handleChange}
                                    maxLength={300}></textarea>
                            </div>
                        </ChatBotFlowCard>
                    </div>
                    <CheckPermissionComponent permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]} userPermission={this.props.userDetail.permissions}>
                        <div className="button mt-auto flex items-end justify-end">
                            <ButtonBorderDarkBlue
                                type="button"
                                className="mr-2"
                                id="btncancel"
                                onClick={() => this.props.showResetFormAlert(this.resetForm)}>Batal</ButtonBorderDarkBlue>
                            <ButtonDarkBlue id="btnsave">Simpan</ButtonDarkBlue>
                        </div>
                    </CheckPermissionComponent>
                </form>
            </>
        )
    }
}

class ChatBotSolutionForm extends Component {
    constructor(props) {
        super(props)

        this.answerListRef = React.createRef()
        this.state = {
            isFormDirty: false,
            currentChatBotMessage: null
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setIsFormDirty()
        }
    }

    async componentDidMount() {
        this.props.clearState()

        this.props.showLoader(true)

        await this.getDetailChatBotSolution()

        this.props.showLoader(false)
    }

    getDetailChatBotSolution = () => {
        return this.props.getDetailChatBotByType(CHATBOT_TYPE.typeSolution)
            .then(res => {
                const data = getContent(res)
                const answers = data.answer_id || []

                this.props.setPreviewMessages([
                    {
                        isBot: true,
                        message: data.bot_message,
                        answers: answers.map(answer => ({
                            answer: answer.answer,
                        })) || []
                    }
                ])

                this.props.setDefaultState({
                    data: {
                        ...this.props.data,
                        backOption: false,
                        automaticMessage: data.bot_message,
                        answerList: answers.map(answer => ({
                            key: uuidv4(),
                            id: answer.id,
                            answer: answer.answer,
                            url_link: answer.url_link,
                            action: answer.action,
                            withLink: answer.url_link !== ''
                        }))
                    }
                })

                this.setState({
                    currentChatBotMessage: data
                })
            })
    }

    setIsFormDirty = () => {
        const { currentChatBotMessage } = this.state
        const { data } = this.props

        if (!currentChatBotMessage) {
            return
        }

        if (currentChatBotMessage.bot_message !== data.automaticMessage) {
            return this.setState({
                isFormDirty: true
            })
        }

        const currentAnswers = currentChatBotMessage.answer_id || []
        const answerList = data.answerList

        if (currentAnswers.length !== answerList.length) {
            return this.setState({
                isFormDirty: true
            })
        }

        for (let i = 0; i < answerList.length; i++) {
            const answer = answerList[i]
            const currentAnswer = currentAnswers[i]

            if (!currentAnswer || answer.answer !== currentAnswer.answer) {
                return this.setState({
                    isFormDirty: true
                })
            }

            if (answer.url_link !== currentAnswer.url_link) {
                return this.setState({
                    isFormDirty: true
                })
            }

            if (answer.action !== currentAnswer.action) {
                return this.setState({
                    isFormDirty: true
                })
            }
        }

        return this.setState({
            isFormDirty: false
        })
    }

    handleSubmit = async e => {
        e.preventDefault()

        if (!CheckPermissionApi(SETTING_CHATBOT_FLOW_UPDATE, this.props.userDetail.permissions)) {
            return
        }

        this.props.showLoader(true)

        await this.props.setErrorAnswers([])

        if (!this.validateData()) {
            this.props.showLoader(false)
            return
        }

        const data = this.props.data
        const body = {
            bot_message: data.automaticMessage,
            opsi_back: data.backOption,
            answer_id: data.answerList
        }

        API_SETTINGS.postChatBotSolution(body, this.props.token)
            .then(async () => {
                this.props.showSuccessAlert()

                await this.getDetailChatBotSolution()

                this.setIsFormDirty()
            })
            .catch(err => this.props.showErrorAlert(getErrorMessage(err)))
            .finally(() => this.props.showLoader(false))
    }

    validateData = () => {
        const data = this.props.data

        const automaticMessageError = this.props.validateAutomaticMessage(data.automaticMessage)
        if (automaticMessageError) {
            this.props.showErrorAlert(automaticMessageError)

            return false
        }

        const errorAnswers = this.props.validateAnswers(data.answerList)

        if (errorAnswers.length > 0) {
            const firstError = errorAnswers[0]

            this.props.showErrorAlert('List Jawaban tidak valid')

            this.props.setErrorAnswers(errorAnswers, () => {
                const target = this.answerListRef.current.children[firstError.index].offsetTop

                this.answerListRef.current.scrollTop = target
            })

            return false
        }

        return true
    }

    mapAnswers = () => {
        const answerList = this.props.data.answerList.filter(answer => answer.action !== "delete")

        return answerList.map((answer, i) => {
            const errorAnswer = this.props.errorAnswers.find(answer => answer.index === i)

            return <LinkedInput
                key={answer.key}
                className="answer-option mb-3"
                toggleLinkClassName="btnlinkattach"
                removeButtonClassName="btndeleteanswer"
                showRemoveButton={CheckPermissionApi(SETTING_CHATBOT_FLOW_UPDATE, this.props.userDetail.permissions)}
                inputClassName="tslanswer"
                placeholder="Tulis Jawaban"
                value={answer.answer}
                onChange={e => this.props.handleAnswerValueChange(e, answer.key)}
                onRemove={() => this.props.handleRemoveAnswer(answer.key)}
                linkPlaceholder="Tulis Link URL"
                linkValue={answer.url_link}
                onAddLink={() => this.props.handleAddLink(answer.key)}
                onLinkChange={e => this.props.handleAnswerLinkValueChange(e, answer.key)}
                onRemoveLink={e => this.props.handleRemoveLink(answer.key)}
                inputErrorMessage={errorAnswer ? errorAnswer.inputError : undefined}
                linkInputErrorMessage={errorAnswer ? errorAnswer.linkError : undefined}
                maxLength={50}
            />
        })
    }

    handleScrollAnswerListToBottom = () => {
        this.answerListRef.current.scrollTop = this.answerListRef.current.scrollHeight
    }

    resetForm = () => {
        const data = this.state.currentChatBotMessage
        const answers = data.answer_id || []

        this.props.setDefaultState({
            data: {
                ...this.props.data,
                backOption: false,
                automaticMessage: data.bot_message,
                answerList: answers.map(answer => ({
                    key: uuidv4(),
                    id: answer.id,
                    answer: answer.answer,
                    url_link: answer.url_link,
                    action: answer.action,
                    withLink: answer.url_link !== ''
                }))
            }
        }, () => this.props.closeResetFormAlert())
    }

    render() {
        return (
            <>
                <RouterPrompt
                    when={this.state.isFormDirty}
                    history={this.props.history}
                />
                <form className="chatbot-flow-form flex flex-col w-2/4 h-full p-6 bg-white shadow-md rounded-md border border-gray-300 overflow-auto" onSubmit={this.handleSubmit}>
                    <div className="mb-10">
                        <h6 className="text-xl font-bold mb-8">Pesan Solusi</h6>
                        <ChatBotFlowCard
                            title="Pesan Otomatis"
                            cardBodyStyles={{
                                height: '400px',
                                maxHeight: '500px'
                            }}>
                            <div className="flex h-full gap-10">
                                <div className="flex-1">
                                    <div className="textarea">
                                        <label className="block mb-1 font-medium" htmlFor="tmlbotmessage">Pesan Otomatis</label>
                                        <textarea
                                            className="form-control resize-none"
                                            id="tmlbotmessage"
                                            cols="30"
                                            rows="5"
                                            placeholder="Tulis Pesan Otomatis"
                                            value={this.props.data.automaticMessage}
                                            name="automaticMessage"
                                            onChange={this.props.handleChange}
                                            maxLength={300}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="flex-1 flex flex-col h-full">
                                    <label className="block mb-1 font-medium">List Jawaban</label>
                                    <div className="max-h-full mb-3 overflow-auto relative" ref={this.answerListRef}>
                                        {this.mapAnswers()}
                                    </div>
                                    <CheckPermissionComponent permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                        <ButtonBorderDarkBlue
                                            id="btnaddanswer"
                                            className="w-full"
                                            onClick={() => this.props.handleAddAnswer(this.handleScrollAnswerListToBottom)}
                                            type="button"
                                        >
                                            <FontAwesomeIcon size="sm" className="mr-1" icon={faPlusCircle} />
                                            <span>Tambah List Jawaban</span>
                                        </ButtonBorderDarkBlue>
                                    </CheckPermissionComponent>
                                </div>
                            </div>
                        </ChatBotFlowCard>
                    </div>
                    <CheckPermissionComponent permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]} userPermission={this.props.userDetail.permissions}>
                        <div className="button mt-auto flex items-center justify-end">
                            <ButtonBorderDarkBlue
                                type="button"
                                className="mr-2"
                                id="btncancel"
                                onClick={() => this.props.showResetFormAlert(this.resetForm)}>Batal</ButtonBorderDarkBlue>
                            <ButtonDarkBlue id="btnsave">Simpan</ButtonDarkBlue>
                        </div>
                    </CheckPermissionComponent>
                </form>
            </>
        )
    }
}

class ChatBotClosingForm extends Component {
    constructor(props) {
        super(props)

        this.relatedAnswerListRef = React.createRef()
        this.chatBotKey = 'chatbot-closing'
        this.chatBotType = 'default-message'

        this.state = {
            currentChatBotMessage: null,
            isFormDirty: false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setIsFormDirty()
        }
    }

    async componentDidMount() {
        this.props.clearState()

        this.props.showLoader(true)

        await this.getDetailChatBotClosing()

        this.getChatBotRelatedAnswers()

        this.props.showLoader(false)
    }

    getDetailChatBotClosing = () => {
        return this.props.getDetailChatBotByType(CHATBOT_TYPE.typeClosing)
            .then(res => {
                const content = getContent(res)

                this.props.setPreviewMessages([
                    {
                        isBot: true,
                        message: content.bot_message,
                    }
                ])

                const selectedAnswers = content.answer_related?.map(answer => ({
                    id: answer.id,
                    answer: answer.answer,
                    action: answer.action
                }))
                this.props.setDefaultState({
                    data: {
                        ...this.props.data,
                        automaticMessage: content.bot_message,
                        relatedAnswers: selectedAnswers || []
                    },
                    currentRelatedAnswers: content?.answer_related || []
                })

                this.setState({
                    currentChatBotMessage: content
                })
            })
    }

    getChatBotRelatedAnswers = (page = 1, limit = 100) => {
        return this.props.getChatBotRelatedAnswers(page, limit, 'default-message', CHATBOT_TYPE.typeClosing)
            .then(res => {
                const content = getContent(res)
                const data = content || []
                const answers = data.map(answer => ({
                    label: answer.answer,
                    value: answer.id
                }))

                answers.sort((a, b) => a.value - b.value)

                this.props.setDefaultState({
                    relatedAnswerOptions: [
                        ...answers
                    ]
                })
            })
    }

    setIsFormDirty = () => {
        const { currentChatBotMessage } = this.state
        const { data } = this.props

        if (!currentChatBotMessage) {
            return
        }

        if (currentChatBotMessage.bot_message !== data.automaticMessage) {
            return this.setState({
                isFormDirty: true
            })
        }

        const currentRelatedAnswers = currentChatBotMessage.answer_related || []
        const relatedAnswers = [...data.relatedAnswers, ...data.removedRelatedAnswers]

        if (currentRelatedAnswers.length !== relatedAnswers.length) {
            return this.setState({
                isFormDirty: true
            })
        }

        for (let i = 0; i < relatedAnswers.length; i++) {
            const relatedAnswer = relatedAnswers[i]
            const currentRelatedAnswer = currentRelatedAnswers[i]

            if (!currentRelatedAnswer || relatedAnswer.answer !== currentRelatedAnswer.answer) {
                return this.setState({
                    isFormDirty: true
                })
            }

            if (relatedAnswer.action !== currentRelatedAnswer.action) {
                return this.setState({
                    isFormDirty: true
                })
            }
        }

        return this.setState({
            isFormDirty: false
        })
    }

    mapRelatedAnswers = () => {
        return this.props.data.relatedAnswers.map(answer => (
            <div key={answer.id} className="related-answer flex justify-between items-center text-secondary-text bg-white p-3 border border-secondary-text-3 rounded-md mb-2">
                <span>{answer.answer}</span>
                <CheckPermissionComponent
                    permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]}
                    userPermission={this.props.userDetail.permissions}
                >
                    <div
                        className="btndeletelistuseranswer"
                        onClick={() => this.props.handleRemoveRelatedAnswer(answer)}
                    >
                        <FontAwesomeIcon
                            className="border-2 border-secondary-text rounded-full w-2.5 h-2.5 p-0.5 cursor-pointer transition-opacity duration-200 hover:opacity-70 select-none"
                            icon={faClose}
                        />
                    </div>
                </CheckPermissionComponent>
            </div>
        ))
    }

    handleSubmit = (e) => {
        e.preventDefault()

        if (!CheckPermissionApi(SETTING_CHATBOT_FLOW_UPDATE, this.props.userDetail.permissions)) {
            return
        }

        this.props.showLoader(true)

        if (!this.validateData()) {
            this.props.showLoader(false)
            return
        }

        const body = {
            bot_message: this.props.data.automaticMessage,
            answer_related: [
                ...this.props.data.relatedAnswers,
                ...this.props.data.removedRelatedAnswers
            ]
        }

        API_SETTINGS.postChatBotClosing(body, this.props.token)
            .then(async () => {
                this.props.showSuccessAlert()

                await this.getDetailChatBotClosing()

                await this.props.clearRemovedRelatedAnswers()

                this.setIsFormDirty()

                this.getChatBotRelatedAnswers()
            })
            .catch(err => this.props.showErrorAlert(getErrorMessage(err)))
            .finally(() => this.props.showLoader(false))
    }

    validateData = () => {
        const data = this.props.data

        const automaticMessageError = this.props.validateAutomaticMessage(data.automaticMessage)
        if (automaticMessageError) {
            this.props.showErrorAlert(automaticMessageError)
            return false
        }

        return true
    }

    resetForm = async () => {
        const content = this.state.currentChatBotMessage

        const selectedAnswers = content.answer_related?.map(answer => ({
            id: answer.id,
            answer: answer.answer,
            action: answer.action
        }))

        this.getChatBotRelatedAnswers()

        await this.props.clearRemovedRelatedAnswers()

        this.props.setDefaultState({
            data: {
                ...this.props.data,
                automaticMessage: content.bot_message,
                relatedAnswers: selectedAnswers || []
            }
        }, () => this.props.closeResetFormAlert())
    }

    render() {
        return (
            <>
                <RouterPrompt
                    when={this.state.isFormDirty}
                    history={this.props.history}
                />
                <form className="chatbot-flow-form w-2/4 flex flex-col h-full p-6 bg-white shadow-md rounded-md border border-gray-300 overflow-auto" onSubmit={this.handleSubmit}>
                    <h6 className="text-xl font-bold mb-8">Pesan Penutup</h6>
                    <div className="flex gap-6 mb-10">
                        <div className="card-form w-full shadow-md rounded-lg border border-gray-300">
                            <div className="card-title text-center p-6 text-xl text-white bg-olddarkblue font-bold rounded-t-lg">Pesan Pengguna</div>
                            <div className="card-body flex flex-col p-6" style={{ height: '350px' }}>
                                <label className="inline-block mb-2 font-medium" htmlFor="ddsinputlistanswer">Terhubung Dengan Jawaban</label>
                                <CheckPermissionComponent
                                    permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]}
                                    userPermission={this.props.userDetail.permissions}
                                >
                                    <Select
                                        id="ddslistanswer"
                                        inputId="ddsinputlistanswer"
                                        className="w-full mb-3"
                                        placeholder="Pilih Jawaban"
                                        options={
                                            [this.props.defaultRelatedAnswer, ...this.props.relatedAnswerOptions]
                                        }
                                        value={this.props.defaultRelatedAnswer}
                                        onChange={(option) => this.props.handleRelatedAnswerChange(option, this.relatedAnswerListRef)}
                                        onInputChange={(value) => this.props.handleSearchRelatedAnswer(value, this.chatBotType, this.chatBotKey)}
                                        isSearchable
                                    />
                                </CheckPermissionComponent>
                                <div className="selected-answers h-full max-h-full overflow-auto" ref={this.relatedAnswerListRef}>
                                    {this.mapRelatedAnswers()}
                                </div>
                            </div>
                        </div>
                        <div className="card-form w-full shadow-md rounded-lg border border-gray-300">
                            <div className="card-title text-center p-6 text-xl text-white bg-olddarkblue font-bold rounded-t-lg">Pesan Otomatis</div>
                            <div className="card-body p-6" style={{ minHeight: '350px' }}>
                                <div className="textarea">
                                    <label className="block mb-1 font-medium" htmlFor="tmlbotmessage">Pesan Otomatis</label>
                                    <textarea
                                        className="form-control resize-none"
                                        id="tmlbotmessage"
                                        cols="30"
                                        rows="5"
                                        placeholder='Tulis Pesan Otomatis'
                                        maxLength={300}
                                        name="automaticMessage"
                                        value={this.props.data.automaticMessage}
                                        onChange={this.props.handleChange}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CheckPermissionComponent permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]} userPermission={this.props.userDetail.permissions}>
                        <div className="button mt-auto flex items-end justify-end">
                            <ButtonBorderDarkBlue
                                type="button"
                                className="mr-2"
                                id="btncancel"
                                onClick={() => this.props.showResetFormAlert(this.resetForm)}>Batal</ButtonBorderDarkBlue>
                            <ButtonDarkBlue id="btnsave">Simpan</ButtonDarkBlue>
                        </div>
                    </CheckPermissionComponent>
                </form>
            </>
        )
    }
}

class ChatBotErrorForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentChatBotMessage: null,
            isFormDirty: false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setIsFormDirty()
        }
    }

    async componentDidMount() {
        this.props.clearState()

        this.props.showLoader(true)

        await this.getDetailChatBotError()

        this.props.showLoader(false)
    }

    getDetailChatBotError = () => {
        return this.props.getDetailChatBotByType(CHATBOT_TYPE.typeError)
            .then(res => {
                const data = getContent(res)

                this.props.setPreviewMessages([
                    {
                        isBot: true,
                        message: data.bot_message,
                    }
                ])

                this.props.setDefaultState({
                    data: {
                        ...this.props.data,
                        automaticMessage: data.bot_message
                    }
                })

                this.setState({
                    currentChatBotMessage: data
                })
            })
    }

    setIsFormDirty = () => {
        const { currentChatBotMessage } = this.state
        const { data } = this.props

        if (!currentChatBotMessage) {
            return
        }

        if (currentChatBotMessage.bot_message !== data.automaticMessage) {
            return this.setState({
                isFormDirty: true
            })
        }

        return this.setState({
            isFormDirty: false
        })
    }

    handleSubmit = e => {
        e.preventDefault()

        if (!CheckPermissionApi(SETTING_CHATBOT_FLOW_UPDATE, this.props.userDetail.permissions)) {
            return
        }

        this.props.showLoader(true)

        if (!this.validateData()) {
            this.props.showLoader(false)
            return
        }

        const body = {
            bot_message: this.props.data.automaticMessage
        }

        API_SETTINGS.postChatBotError(body, this.props.token)
            .then(async () => {
                this.props.showSuccessAlert()

                await this.getDetailChatBotError()

                this.setIsFormDirty()
            })
            .catch(err => this.props.showErrorAlert(getErrorMessage(err)))
            .finally(() => this.props.showLoader(false))
    }

    validateData = () => {
        const data = this.props.data

        const automaticMessageError = this.props.validateAutomaticMessage(data.automaticMessage)
        if (automaticMessageError) {
            this.props.showErrorAlert(automaticMessageError)

            return false
        }

        return true
    }

    resetForm = () => {
        const data = this.state.currentChatBotMessage

        this.props.setDefaultState({
            data: {
                ...this.props.data,
                automaticMessage: data.bot_message
            }
        }, () => this.props.closeResetFormAlert())
    }

    render() {
        return (
            <>
                <RouterPrompt
                    when={this.state.isFormDirty}
                    history={this.props.history}
                />
                <form className="chatbot-flow-form flex flex-col w-2/4 h-full p-6 bg-white shadow-md rounded-md border border-gray-300 overflow-auto" onSubmit={this.handleSubmit}>
                    <div className="mb-10">
                        <h6 className="text-xl font-bold mb-8">Pesan Eror</h6>
                        <ChatBotFlowCard
                            title="Pesan Otomatis"
                            cardBodyStyles={{
                                height: '400px',
                                maxHeight: '500px'
                            }}>
                            <div>
                                <label className="inline-block font-medium mb-1" htmlFor="tmlbotmessage">Pesan Otomatis</label>
                                <textarea
                                    className="form-control resize-none"
                                    id="tmlbotmessage"
                                    name="automaticMessage"
                                    cols="30"
                                    rows="8"
                                    placeholder="Tulis Pesan Otomatis"
                                    maxLength={300}
                                    onChange={this.props.handleChange}
                                    value={this.props.data.automaticMessage}></textarea>
                            </div>
                        </ChatBotFlowCard>
                    </div>
                    <CheckPermissionComponent permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]} userPermission={this.props.userDetail.permissions}>
                        <div className="button mt-auto flex items-end justify-end">
                            <ButtonBorderDarkBlue
                                type="button"
                                className="mr-2"
                                id="btncancel"
                                onClick={() => this.props.showResetFormAlert(this.resetForm)}>Batal</ButtonBorderDarkBlue>
                            <ButtonDarkBlue id="btnsave">Simpan</ButtonDarkBlue>
                        </div>
                    </CheckPermissionComponent>
                </form>
            </>
        )
    }
}

class ChatBotCreateTicketForm extends Component {
    constructor(props) {
        super(props)

        this.automaticMessageCardBodyRef = React.createRef()
        this.answerListRef = React.createRef()
        this.relatedAnswerListRef = React.createRef()
        this.defaultAnswerKey = 'DEFAULT_ANSWER'
        this.defaultAnswerValue = 'Link Buat Ticket'
        this.chatBotKey = 'chatbot-create-ticket'
        this.chatBotType = 'default-message'
        this.state = {
            currentChatBotMessage: null,
            isFormDirty: false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setIsFormDirty()
        }
    }

    async componentDidMount() {
        this.props.clearState()

        this.props.showLoader(true)

        await this.getDetailChatBotCreateTicket()

        this.getChatBotRelatedAnswers()

        this.props.showLoader(false)
    }

    getDetailChatBotCreateTicket = () => {
        return this.props.getDetailChatBotByType(CHATBOT_TYPE.typeCreateTicket)
            .then(res => {
                const content = getContent(res)
                content.answer_id = this.getSortedAnswerList(content.answer_id || [])

                const selectedAnswers = content.answer_related?.map(answer => ({
                    id: answer.id,
                    answer: answer.answer,
                    action: answer.action
                }))

                let answers = content.answer_id?.map(answer => ({
                    key: uuidv4(),
                    id: answer.id,
                    answer: answer.answer,
                    url_link: answer.url_link,
                    action: answer.action,
                    withLink: answer.url_link !== ''
                }))

                answers = this.addDefaultAnswer(answers)

                this.props.setPreviewMessages([
                    {
                        isBot: true,
                        message: content.bot_message,
                        answers: content.answer_id?.map(answer => ({
                            answer: answer.answer,
                        })) || []
                    }
                ])

                this.props.setDefaultState({
                    data: {
                        ...this.props.data,
                        automaticMessage: content.bot_message,
                        relatedAnswers: selectedAnswers || [],
                        answerList: answers || []
                    },
                    currentRelatedAnswers: content?.answer_related || []
                })

                this.setState({
                    currentChatBotMessage: content
                })
            })
    }

    getSortedAnswerList = (answers = []) => {
        const defaultAnswer = answers.find(answer => answer.url_link === chatBotCreateTicketUrl)

        if (defaultAnswer) {
            return [defaultAnswer, ...answers.filter(answer => answer.url_link !== chatBotCreateTicketUrl)]
        }

        return answers
    }

    addDefaultAnswer = (answers = []) => {
        const defaultAnswer = {
            key: this.defaultAnswerKey,
            id: 0,
            answer: this.defaultAnswerValue,
            url_link: chatBotCreateTicketUrl,
            action: 'insert',
            withLink: true
        }

        const existingDefaultAnswerIndex = answers.findIndex(answer => answer.url_link === chatBotCreateTicketUrl)
        if (existingDefaultAnswerIndex > -1) {
            const tempAnswer = answers[existingDefaultAnswerIndex]

            tempAnswer.key = this.defaultAnswerKey
            return [tempAnswer, ...answers.filter(answer => answer.id !== tempAnswer.id)]
        }

        answers = [defaultAnswer, ...answers]
        return answers
    }

    getChatBotRelatedAnswers = (page = 1, limit = 100) => {
        return this.props.getChatBotRelatedAnswers(page, limit, 'default-message', CHATBOT_TYPE.typeCreateTicket)
            .then(res => {
                const content = getContent(res)
                const data = content || []
                const answers = data.map(answer => ({
                    label: answer.answer,
                    value: answer.id
                }))

                answers.sort((a, b) => a.value - b.value)

                this.props.setDefaultState({
                    relatedAnswerOptions: [
                        ...answers
                    ]
                })
            })
    }

    setIsFormDirty = () => {
        const { currentChatBotMessage } = this.state
        const { data } = this.props

        if (!currentChatBotMessage) {
            return
        }

        if (currentChatBotMessage.bot_message !== data.automaticMessage) {
            return this.setState({
                isFormDirty: true
            })
        }

        /*
            Related Answers
        */
        const currentRelatedAnswers = currentChatBotMessage.answer_related || []
        const relatedAnswers = [...data.relatedAnswers, ...data.removedRelatedAnswers]

        if (currentRelatedAnswers.length !== relatedAnswers.length) {
            return this.setState({
                isFormDirty: true
            })
        }

        for (let i = 0; i < relatedAnswers.length; i++) {
            const relatedAnswer = relatedAnswers[i]
            const currentRelatedAnswer = currentRelatedAnswers[i]

            if (!currentRelatedAnswer || relatedAnswer.answer !== currentRelatedAnswer.answer) {
                return this.setState({
                    isFormDirty: true
                })
            }

            if (relatedAnswer.action !== currentRelatedAnswer.action) {
                return this.setState({
                    isFormDirty: true
                })
            }
        }

        /*
            Answer List
        */
        const currentAnswers = currentChatBotMessage.answer_id || []
        const answers = data.answerList

        if (currentAnswers.length !== answers.length) {
            return this.setState({
                isFormDirty: true
            })
        }

        for (let i = 0; i < answers.length; i++) {
            const answer = answers[i]
            const currentAnswer = currentAnswers[i]

            if (!currentAnswer || answer.answer !== currentAnswer.answer) {
                return this.setState({
                    isFormDirty: true
                })
            }

            if (answer.url_link !== currentAnswer.url_link) {
                return this.setState({
                    isFormDirty: true
                })
            }

            if (answer.action !== currentAnswer.action) {
                return this.setState({
                    isFormDirty: true
                })
            }
        }

        return this.setState({
            isFormDirty: false
        })
    }

    mapRelatedAnswers = () => {
        return this.props.data.relatedAnswers.map(answer => (
            <div key={answer.id} className="related-answer flex justify-between items-center text-secondary-text bg-white p-3 border border-secondary-text-3 rounded-md mb-2">
                <span>{answer.answer}</span>
                <CheckPermissionComponent
                    permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]}
                    userPermission={this.props.userDetail.permissions}
                >
                    <div
                        className="btndeletelistuseranswer"
                        onClick={() => this.props.handleRemoveRelatedAnswer(answer)}
                    >
                        <FontAwesomeIcon
                            className="border-2 border-secondary-text rounded-full w-2.5 h-2.5 p-0.5 cursor-pointer transition-opacity duration-200 hover:opacity-70 select-none"
                            icon={faClose}
                        />
                    </div>
                </CheckPermissionComponent>
            </div>
        ))
    }

    mapAnswers = () => {
        const answerList = this.props.data.answerList.filter(answer => answer.action !== "delete")

        return answerList.map((answer, i) => {
            const errorAnswer = this.props.errorAnswers.find(answer => answer.index === i)
            const isDefaultAnswer = answer.key === this.defaultAnswerKey

            return <LinkedInput
                key={answer.key}
                className="answer-option mb-3"
                toggleLinkClassName="btnlinkattach"
                removeButtonClassName="btndeleteanswer"
                hideAddLinkButton={isDefaultAnswer}
                hideRemoveButton={isDefaultAnswer}
                readOnlyLinkInput={isDefaultAnswer}
                showRemoveButton={CheckPermissionApi(SETTING_CHATBOT_FLOW_UPDATE, this.props.userDetail.permissions)}
                inputClassName="tslanswer"
                placeholder="Tulis Jawaban"
                value={answer.answer}
                onChange={e => this.props.handleAnswerValueChange(e, answer.key)}
                onRemove={() => this.props.handleRemoveAnswer(answer.key)}
                linkPlaceholder="Tulis Link URL"
                linkValue={answer.url_link}
                onAddLink={() => this.props.handleAddLink(answer.key)}
                onLinkChange={e => this.props.handleAnswerLinkValueChange(e, answer.key)}
                onRemoveLink={e => this.props.handleRemoveLink(answer.key)}
                inputErrorMessage={errorAnswer ? errorAnswer.inputError : undefined}
                linkInputErrorMessage={errorAnswer ? errorAnswer.linkError : undefined}
                maxLength={50}
            />
        })
    }

    handleScrollAnswerListToBottom = () => {
        this.answerListRef.current.scrollTop = this.answerListRef.current.scrollHeight
        this.automaticMessageCardBodyRef.current.scrollTop = this.automaticMessageCardBodyRef.current.scrollHeight
    }

    handleSubmit = (e) => {
        e.preventDefault()

        if (!CheckPermissionApi(SETTING_CHATBOT_FLOW_UPDATE, this.props.userDetail.permissions)) {
            return
        }

        this.props.showLoader(true)

        this.props.setErrorAnswers([])

        if (!this.validateData()) {
            this.props.showLoader(false)
            return
        }

        const body = {
            bot_message: this.props.data.automaticMessage,
            answer_id: this.props.data.answerList,
            answer_related: [
                ...this.props.data.relatedAnswers,
                ...this.props.data.removedRelatedAnswers
            ],
        }

        API_SETTINGS.postChatBotCreateTicket(body, this.props.token)
            .then(async () => {
                this.props.showSuccessAlert()

                await this.getDetailChatBotCreateTicket()

                this.props.clearRemovedRelatedAnswers()

                this.getChatBotRelatedAnswers()

                this.setIsFormDirty()
            })
            .catch(err => this.props.showErrorAlert(getErrorMessage(err)))
            .finally(() => this.props.showLoader(false))
    }

    validateData = () => {
        const data = this.props.data

        const automaticMessageError = this.props.validateAutomaticMessage(data.automaticMessage)
        if (automaticMessageError) {
            this.props.showErrorAlert(automaticMessageError)

            return false
        }

        const errorAnswers = this.props.validateAnswers(data.answerList)

        if (errorAnswers.length > 0) {
            const firstError = errorAnswers[0]

            this.props.showErrorAlert('List Jawaban tidak valid')

            this.props.setErrorAnswers(errorAnswers, () => {
                const target = this.answerListRef.current.children[firstError.index].offsetTop

                this.answerListRef.current.scrollTop = target
                this.automaticMessageCardBodyRef.current.scrollTop = this.automaticMessageCardBodyRef.current.scrollHeight
            })

            return false
        }

        return true
    }

    resetForm = async () => {
        const content = this.state.currentChatBotMessage

        const selectedAnswers = content.answer_related?.map(answer => ({
            id: answer.id,
            answer: answer.answer,
            action: answer.action
        }))

        const answers = content.answer_id?.map(answer => ({
            key: uuidv4(),
            id: answer.id,
            answer: answer.answer,
            url_link: answer.url_link,
            action: answer.action,
            withLink: answer.url_link !== ''
        }))

        this.getChatBotRelatedAnswers()

        await this.props.clearRemovedRelatedAnswers()

        this.props.setDefaultState({
            data: {
                ...this.props.data,
                automaticMessage: content.bot_message,
                relatedAnswers: selectedAnswers || [],
                answerList: answers || []
            },
        }, () => this.props.closeResetFormAlert())
    }

    render() {
        return (
            <>
                <RouterPrompt
                    when={this.state.isFormDirty}
                    history={this.props.history}
                />
                <form className="chatbot-flow-form w-2/4 flex flex-col h-full p-6 bg-white shadow-md rounded-md border border-gray-300 overflow-auto" onSubmit={this.handleSubmit}>
                    <h6 className="text-xl font-bold mb-8">Pesan Buat Tiket</h6>
                    <div className="flex gap-6 mb-10">
                        <div className="card-form w-full shadow-md rounded-lg border border-gray-300">
                            <div className="card-title text-center p-6 text-xl text-white bg-olddarkblue font-bold rounded-t-lg">Pesan Pengguna</div>
                            <div className="card-body flex flex-col p-6 h-full" style={{ maxHeight: '400px' }}>
                                <label className="inline-block mb-2 font-medium" htmlFor="ddsinputlistanswer">Terhubung Dengan Jawaban</label>
                                <CheckPermissionComponent permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                    <Select
                                        id="ddslistanswer"
                                        inputId="ddsinputlistanswer"
                                        className="w-full mb-3"
                                        placeholder="Pilih Jawaban"
                                        options={
                                            [this.props.defaultRelatedAnswer, ...this.props.relatedAnswerOptions]
                                        }
                                        value={this.props.defaultRelatedAnswer}
                                        onChange={(option) => this.props.handleRelatedAnswerChange(option, this.relatedAnswerListRef)}
                                        onInputChange={(value) => this.props.handleSearchRelatedAnswer(value, this.chatBotType, this.chatBotKey)}
                                    />
                                </CheckPermissionComponent>
                                <div className="selected-answers h-full max-h-full overflow-auto" ref={this.relatedAnswerListRef}>
                                    {this.mapRelatedAnswers()}
                                </div>
                            </div>
                        </div>
                        <div className="card-form w-full shadow-md rounded-lg border border-gray-300">
                            <div className="card-title text-center p-6 text-xl text-white bg-olddarkblue font-bold rounded-t-lg">Pesan Otomatis</div>
                            <div className="card-body py-6" style={{ height: '400px', maxHeight: '400px' }}>
                                <div className="px-6 h-full max-h-full overflow-auto" ref={this.automaticMessageCardBodyRef}>
                                    <div className="textarea mb-3">
                                        <label className="block mb-1 font-medium" htmlFor="tmlbotmessage">Pesan Otomatis</label>
                                        <textarea
                                            className="form-control resize-none"
                                            id="tmlbotmessage"
                                            cols="30"
                                            rows="5"
                                            placeholder="Tulis Pesan Otomatis"
                                            name="automaticMessage"
                                            value={this.props.data.automaticMessage}
                                            onChange={this.props.handleChange}
                                            maxLength={300}
                                        ></textarea>
                                    </div>
                                    <div className="answer-list">
                                        <label className="block mb-1 font-medium">List Jawaban</label>
                                        <div className="max-h-full mb-3 overflow-auto relative" style={{ maxHeight: '300px' }} ref={this.answerListRef}>
                                            {this.mapAnswers()}
                                        </div>
                                        <CheckPermissionComponent
                                            permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]}
                                            userPermission={this.props.userDetail.permissions}
                                        >
                                            <ButtonBorderDarkBlue
                                                id="btnaddanswer"
                                                className="w-full mb-1"
                                                onClick={() => this.props.handleAddAnswer(this.handleScrollAnswerListToBottom)}
                                                type="button"
                                            >
                                                <FontAwesomeIcon size="sm" className="mr-1" icon={faPlusCircle} />
                                                <span>Tambah List Jawaban</span>
                                            </ButtonBorderDarkBlue>
                                        </CheckPermissionComponent>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CheckPermissionComponent permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]} userPermission={this.props.userDetail.permissions}>
                        <div className="button mt-auto flex items-center justify-end">
                            <ButtonBorderDarkBlue
                                type="button"
                                className="mr-2"
                                id="btncancel"
                                onClick={() => this.props.showResetFormAlert(this.resetForm)}>Batal</ButtonBorderDarkBlue>
                            <ButtonDarkBlue id="btnsave">Simpan</ButtonDarkBlue>
                        </div>
                    </CheckPermissionComponent>
                </form>
            </>
        )
    }
}

class ChatBotTimeoutForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentChatBotMessage: null,
            isFormDirty: false,
            errorMessages: {
                chatTimeout: '',
                closingDuration: ''
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setIsFormDirty()
        }
    }

    async componentDidMount() {
        this.props.clearState()

        this.props.showLoader(true)

        await this.getDetailChatBotTimeout()

        this.props.showLoader(false)
    }

    getDetailChatBotTimeout = () => {
        return this.props.getDetailChatBotByType(CHATBOT_TYPE.typeTimeout)
            .then(res => {
                const content = getContent(res)
                const parameters = content.parameters || []

                this.props.setPreviewMessages([
                    {
                        isBot: true,
                        message: content.bot_message
                    }
                ])

                this.props.setDefaultState({
                    data: {
                        ...this.props.data,
                        automaticMessage: content.bot_message,
                        parameters: content.parameters,
                        chatTimeout: this.getParameterValueByName(parameters, "timeoutchatbot"),
                        closingDuration: this.getParameterValueByName(parameters, "closingchatbot")
                    },
                })

                this.setState({
                    currentChatBotMessage: content
                })
            })
    }

    getParameterValueByName = (parameters, name) => {
        return parameters.find(parameter => parameter.name === name)?.value || '0'
    }

    getParameterByName = (parameters, name) => {
        return parameters.find(parameter => parameter.name === name)
    }

    setErrorMessages = (state) => {
        this.setState({
            errorMessages: {
                ...this.state.errorMessages,
                ...state
            }
        })
    }

    clearErrorMessages = () => {
        return this.setState({
            errorMessages: {
                chatTimeout: '',
                closingDuration: ''
            }
        })
    }

    setIsFormDirty = () => {
        const { currentChatBotMessage } = this.state
        const { data } = this.props

        if (!currentChatBotMessage) {
            return
        }

        if (currentChatBotMessage.bot_message !== data.automaticMessage) {
            return this.setState({
                isFormDirty: true
            })
        }

        const currentChatTimeout = currentChatBotMessage.parameters.find(param => param.name === 'timeoutchatbot')
        if (currentChatTimeout.value !== data.chatTimeout) {
            return this.setState({
                isFormDirty: true
            })
        }

        const currentClosingDuration = currentChatBotMessage.parameters.find(param => param.name === 'closingchatbot')
        if (currentClosingDuration.value !== data.closingDuration) {
            return this.setState({
                isFormDirty: true
            })
        }

        return this.setState({
            isFormDirty: false
        })
    }

    handleSubmit = async e => {
        e.preventDefault()

        if (!CheckPermissionApi(SETTING_CHATBOT_FLOW_UPDATE, this.props.userDetail.permissions)) {
            return
        }

        this.props.showLoader(true)

        await this.clearErrorMessages()

        if (!this.validateData()) {
            this.props.showLoader(false)
            return
        }

        const parameters = this.props.data.parameters

        const chatTimeoutParameter = this.getParameterByName(parameters, "timeoutchatbot")
        chatTimeoutParameter.value = this.props.data.chatTimeout + ""

        const closingDurationParameter = this.getParameterByName(parameters, "closingchatbot")
        closingDurationParameter.value = this.props.data.closingDuration + ""

        const body = {
            bot_message: this.props.data.automaticMessage,
            parameters: [chatTimeoutParameter, closingDurationParameter]
        }

        API_SETTINGS.postChatBotTimeout(body, this.props.token)
            .then(async () => {
                this.props.showSuccessAlert()

                await this.getDetailChatBotTimeout()

                this.setIsFormDirty()
            })
            .catch(err => this.props.showErrorAlert(getErrorMessage(err)))
            .finally(() => this.props.showLoader(false))
    }

    validateData = () => {
        const data = this.props.data

        const automaticMessageError = this.props.validateAutomaticMessage(data.automaticMessage)
        if (automaticMessageError) {
            this.props.showErrorAlert(automaticMessageError)

            return false
        }

        const chatTimeoutError = this.validateChatBotTimeout(data.chatTimeout)
        if (chatTimeoutError) {
            this.setErrorMessages({
                chatTimeout: chatTimeoutError
            })
        }

        const closingDurationError = this.validateClosingDuration(data.closingDuration)
        if (closingDurationError) {
            this.setErrorMessages({
                closingDuration: closingDurationError
            })
        }

        if (chatTimeoutError || closingDurationError) {
            this.props.showErrorAlert('Gagal menyimpan data')

            return false
        }

        return true
    }

    validateChatBotTimeout = (chatTimeout) => {
        if (parseInt(chatTimeout) < 60 || parseInt(chatTimeout) > 300) {
            return 'Hanya boleh diisi dengan nilai 60 sampai 300'
        }

        return ''
    }

    validateClosingDuration = (closingDuration) => {
        if (parseInt(closingDuration) < 60 || parseInt(closingDuration) > 300) {
            return 'Hanya boleh diisi dengan nilai 60 sampai 300'
        }

        return ''
    }

    resetForm = () => {
        const content = this.state.currentChatBotMessage
        const parameters = content.parameters || []

        this.props.setDefaultState({
            data: {
                ...this.props.data,
                automaticMessage: content.bot_message,
                parameters: content.parameters,
                chatTimeout: this.getParameterValueByName(parameters, "timeoutchatbot"),
                closingDuration: this.getParameterValueByName(parameters, "closingchatbot")
            },
        }, () => this.props.closeResetFormAlert())
    }

    render() {
        return (
            <>
                <RouterPrompt
                    when={this.state.isFormDirty}
                    history={this.props.history}
                />
                <form className="chatbot-flow-form z-10 flex flex-col w-2/4 h-full p-6 overflow-y-auto overflow-x-visible bg-white shadow-md rounded-md border border-gray-300" onSubmit={this.handleSubmit}>
                    <div className="mb-10">
                        <h6 className="text-xl font-bold mb-8">Pesan Timeout</h6>
                        <ChatBotFlowCard
                            title="Pesan Otomatis"
                            cardBodyStyles={{
                                height: '400px',
                                maxHeight: '400px'
                            }}>
                            <div className="flex gap-5">
                                <div className="flex-1">
                                    <UnitInput
                                        className="mb-5"
                                        id="tsltimeoutmessage"
                                        name="chatTimeout"
                                        label="Batas Waktu Pesan"
                                        placeholder="Tulis batas waktu pesan"
                                        unit="Detik"
                                        info="Batas waktu pesan digunakan untuk pengiriman pesan batas waktu berakhir kepada pengguna. Hal terjadi jika pelanggan tidak merespon dalam waktu tertentu."
                                        value={this.props.data.chatTimeout}
                                        onChange={this.props.handleChangeNumberOnly}
                                        errorMessage={this.state.errorMessages.chatTimeout}
                                    />
                                    <UnitInput
                                        id="tslclosingmessage"
                                        name="closingDuration"
                                        label="Durasi Penutupan"
                                        placeholder="Tulis durasi penutupan"
                                        unit="Detik"
                                        info="Durasi penutupan digunakan untuk mengirimkan pesan penutupan kepada pelanggan selama batas waktu yang tertulis setelah pengiriman batas waktu pesan."
                                        value={this.props.data.closingDuration}
                                        onChange={this.props.handleChangeNumberOnly}
                                        errorMessage={this.state.errorMessages.closingDuration}
                                    />
                                </div>
                                <div className="flex-1">
                                    <div>
                                        <label className="inline-block font-medium mb-1" htmlFor="tmlbotmessage">Pesan Otomatis</label>
                                        <textarea
                                            className="form-control resize-none"
                                            id="tmlbotmessage"
                                            name="automaticMessage"
                                            cols="30"
                                            rows="8"
                                            placeholder="Tulis Pesan Otomatis"
                                            value={this.props.data.automaticMessage}
                                            onChange={this.props.handleChange}
                                            maxLength={300}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </ChatBotFlowCard>
                    </div>
                    <CheckPermissionComponent permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]} userPermission={this.props.userDetail.permissions}>
                        <div className="button mt-auto flex items-center justify-end">
                            <ButtonBorderDarkBlue
                                type="button"
                                className="mr-2"
                                id="btncancel"
                                onClick={() => this.props.showResetFormAlert(this.resetForm)}>Batal</ButtonBorderDarkBlue>
                            <ButtonDarkBlue id="btnsave">Simpan</ButtonDarkBlue>
                        </div>
                    </CheckPermissionComponent>
                </form>
            </>
        )
    }
}

class ChatBotQuestionAndAnswerForm extends Component {
    constructor(props) {
        super(props)

        this.automaticMessageCardRef = React.createRef()
        this.answerListRef = React.createRef()
        this.relatedAnswerListRef = React.createRef()
        this.chatBotType = 'chatbot-question'

        this.state = {
            kmsOptions: [],
            currentChatBotMessage: null,
            isFormDirty: false,
            isFirstMessageDisabled: false,
            disabledFields: {
                isFirstMessage: false,
                backOption: false,
                isRelatedToSolution: false,
                kmsId: false,
                kms: false,
            }
        }
    }

    componentDidUpdate = async (prevProps) => {
        if (prevProps.qnaId !== this.props.qnaId) {
            this.props.clearState()
            this.props.clearPreviewMessages()

            await this.getData()
            await this.checkFirstMessage()
        }

        if (prevProps.isCreate !== this.props.isCreate) {
            if (this.props.isCreate) {
                this.setState({
                    isFormDirty: true
                })
            }
        }

        if (prevProps.data !== this.props.data) {
            this.setDisabledFields()
            this.setIsFormDirty()
        }

    }

    componentDidMount() {
        this._isMounted = true

        this.props.clearState()
        this.props.clearPreviewMessages()

        if (this.props.isCreate) {
            this.setState({
                isFormDirty: true
            })
        }

        this.getData()
        this.checkFirstMessage()

        this.setDisabledFields()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    getData = async () => {
        if (!this.props.isCreate) {
            this.props.showLoader(true)

            await this.getDetailChatBotById(this.props.qnaId)

            this.props.showLoader(false)
        }

        this.getChatBotRelatedAnswers()
        this.getChatBotKMS()
    }

    getDetailChatBotById = (id) => {
        return API_SETTINGS.getDetailChatBotQNAById(id, this.props.token)
            .then((res) => {
                if (this._isMounted) {   
                    const content = getContent(res)
    
                    /* 
                        Data Not Found
                    */
                    if (content.id === 0) {
                        return this.props.setIsQNAFound(false)
                    }
    
                    /* 
                        Data is found
                    */
                    const relatedAnswers = content.answer_related?.map(answer => ({
                        id: answer.id,
                        answer: answer.answer,
                        action: answer.action
                    }))
    
                    const answers = content.answer_id?.map(answer => ({
                        key: uuidv4(),
                        id: answer.id,
                        answer: answer.answer,
                        url_link: answer.url_link,
                        action: answer.action,
                        withLink: answer.url_link !== ''
                    }))
    
                    this.props.setPreviewMessages([
                        {
                            isBot: true,
                            message: content.bot_message,
                            backOption: content.opsi_back,
                            answers: content.answer_id?.map(answer => ({
                                answer: answer.answer,
                            })) || []
                        }
                    ])
    
                    const kms = content.kms_id !== 0 ? {
                        label: content.kms,
                        value: content.kms_id
                    } : null
    
                    this.props.setDefaultState({
                        data: {
                            ...this.props.data,
                            automaticMessage: content.bot_message,
                            qnaName: content.question,
                            isFirstMessage: content.first_message,
                            backOption: content.opsi_back,
                            isRelatedToSolution: content.is_related_to_solution,
                            kmsId: content.kms_id,
                            relatedAnswers: relatedAnswers || [],
                            answerList: answers || [],
                            kms
                        },
                        currentRelatedAnswers: content?.answer_related || []
                    })
    
                    this.setState({
                        currentChatBotMessage: content
                    })
                }
            })
            .catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }

                if (getErrorCode(err) === "E-4-CARE-SRV-003") {
                    this.props.setIsQNAFound(false)
                }
            })
    }

    getChatBotRelatedAnswers = (page = 1, limit = 100) => {
        return this.props.getChatBotRelatedAnswers(page, limit, CHATBOT_TYPE.typeQuestion, this.props.qnaId)
            .then(res => {
                if (this._isMounted) {
                    const content = getContent(res)
                    const data = content || []
                    const answers = data.map(answer => ({
                        label: answer.answer,
                        value: answer.id
                    }))
    
                    answers.sort((a, b) => a.value - b.value)
    
                    this.props.setDefaultState({
                        relatedAnswerOptions: [
                            ...answers
                        ]
                    })
                }
            })
    }

    getChatBotKMS = (page = 1, limit = 50, keyword = '') => {
        return API_SETTINGS.getChatBotKMS(page, limit, keyword, this.props.token)
            .then((res) => {
                if (this._isMounted) {   
                    const content = getContent(res)
    
                    const kmsOptions = content?.map(kms => ({
                        label: kms.title,
                        value: kms.id
                    }))
    
                    this.setState({
                        kmsOptions: kmsOptions || []
                    })
                }
            })
            .catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    checkFirstMessage = () => {
        return API_SETTINGS.checkChatBotFirstMessage(this.props.token)
            .then(res => {
                if (this._isMounted) {   
                    const firstMessageStatus = getContent(res)
                    const currentChatBotMessage = this.state.currentChatBotMessage
    
                    if (this.props.isCreate) {
                        this.setState({
                            isFirstMessageDisabled: !firstMessageStatus
                        })
    
                        return
                    }
    
                    if (!firstMessageStatus && !currentChatBotMessage.first_message) {
                        this.setState({
                            isFirstMessageDisabled: true
                        })
    
                        return
                    }
    
                    this.setState({
                        isFirstMessageDisabled: false
                    })
                }
            })
            .catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    setDisabledFields = () => {
        const { data } = this.props

        const disabledFields = {
            isFirstMessage: false,
            backOption: false,
            isRelatedToSolution: false,
            kmsId: false
        }

        if (data.isFirstMessage) {
            disabledFields.backOption = true
            disabledFields.isRelatedToSolution = true
        }

        if (data.backOption) {
            disabledFields.isFirstMessage = true
            disabledFields.isRelatedToSolution = true
        }

        if (data.isRelatedToSolution) {
            disabledFields.backOption = true
        }

        if (!data.isRelatedToSolution) {
            disabledFields.kmsId = true
        }

        if (this.state.isFirstMessageDisabled) {
            disabledFields.isFirstMessage = true
        }

        this.setState({
            disabledFields
        })
    }

    getDisabledBody = (body) => {
        const {
            isFirstMessage,
            backOption,
            isRelatedToSolution,
            kmsId
        } = this.state.disabledFields

        body.first_message = isFirstMessage ? false : body.first_message
        body.opsi_back = backOption ? false : body.opsi_back
        body.is_related_to_solution = isRelatedToSolution ? false : body.is_related_to_solution
        body.kms_id = kmsId ? 0 : body.kms_id

        return body
    }

    setIsFormDirty = () => {
        const { currentChatBotMessage } = this.state
        const { data } = this.props

        if (!currentChatBotMessage) {
            return
        }

        if (currentChatBotMessage.question !== data.qnaName) {
            return this.setState({
                isFormDirty: true
            })
        }

        if (currentChatBotMessage.bot_message !== data.automaticMessage) {
            return this.setState({
                isFormDirty: true
            })
        }

        if (currentChatBotMessage.first_message !== data.isFirstMessage) {
            return this.setState({
                isFormDirty: true
            })
        }

        if (currentChatBotMessage.opsi_back !== data.backOption) {
            return this.setState({
                isFormDirty: true
            })
        }

        if (currentChatBotMessage.is_related_to_solution !== data.isRelatedToSolution) {
            return this.setState({
                isFormDirty: true
            })
        }

        if (currentChatBotMessage.kms_id !== (data?.kms?.value || 0)) {
            return this.setState({
                isFormDirty: true
            })
        }

        /*
            Related Answers
        */
        const currentRelatedAnswers = currentChatBotMessage.answer_related || []
        const relatedAnswers = [...data.relatedAnswers, ...data.removedRelatedAnswers]

        if (currentRelatedAnswers.length !== relatedAnswers.length) {
            return this.setState({
                isFormDirty: true
            })
        }

        for (let i = 0; i < relatedAnswers.length; i++) {
            const relatedAnswer = relatedAnswers[i]
            const currentRelatedAnswer = currentRelatedAnswers[i]

            if (!currentRelatedAnswer || relatedAnswer.id !== currentRelatedAnswer.id) {
                return this.setState({
                    isFormDirty: true
                })
            }

            if (relatedAnswer.action !== currentRelatedAnswer.action) {
                return this.setState({
                    isFormDirty: true
                })
            }
        }

        /*
            Answer List
        */
        const currentAnswers = currentChatBotMessage.answer_id || []
        const answers = data.answerList

        if (currentAnswers.length !== answers.length) {
            return this.setState({
                isFormDirty: true
            })
        }

        for (let i = 0; i < answers.length; i++) {
            const answer = answers[i]
            const currentAnswer = currentAnswers[i]

            if (!currentAnswer || answer.answer !== currentAnswer.answer) {
                return this.setState({
                    isFormDirty: true
                })
            }

            if (answer.url_link !== currentAnswer.url_link) {
                return this.setState({
                    isFormDirty: true
                })
            }

            if (answer.action !== currentAnswer.action) {
                return this.setState({
                    isFormDirty: true
                })
            }
        }

        return this.setState({
            isFormDirty: false
        })
    }

    mapAnswers = () => {
        const answerList = this.props.data.answerList.filter(answer => answer.action !== "delete")

        return answerList.map((answer, i) => {
            const errorAnswer = this.props.errorAnswers.find(answer => answer.index === i)

            return <LinkedInput
                key={answer.key}
                className="answer-option mb-3"
                toggleLinkClassName="btnlinkattach"
                removeButtonClassName="btndeleteanswer"
                showRemoveButton={
                    this.props.isCreate
                        ? CheckPermissionApi(SETTING_CHATBOT_FLOW_INSERT, this.props.userDetail.permissions)
                        : CheckPermissionApi(SETTING_CHATBOT_FLOW_UPDATE, this.props.userDetail.permissions)
                }
                inputClassName="tslanswer"
                placeholder="Tulis Jawaban"
                value={answer.answer}
                onChange={e => this.props.handleAnswerValueChange(e, answer.key)}
                onRemove={() => this.props.handleRemoveAnswer(answer.key)}
                linkPlaceholder="Tulis Link URL"
                linkValue={answer.url_link}
                onAddLink={() => this.props.handleAddLink(answer.key)}
                onLinkChange={e => this.props.handleAnswerLinkValueChange(e, answer.key)}
                onRemoveLink={() => this.props.handleRemoveLink(answer.key)}
                inputErrorMessage={errorAnswer ? errorAnswer.inputError : undefined}
                linkInputErrorMessage={errorAnswer ? errorAnswer.linkError : undefined}
                maxLength={100}
            />
        })
    }

    mapRelatedAnswers = () => {
        return this.props.data.relatedAnswers.map(answer => (
            <div key={answer.id} className="related-answer flex justify-between items-center text-secondary-text bg-white p-3 border border-secondary-text-3 rounded-md mb-2">
                <span>{answer.answer}</span>
                <CheckPermissionComponent
                    permissionConstant={this.props.isCreate ? [SETTING_CHATBOT_FLOW_INSERT] : [SETTING_CHATBOT_FLOW_UPDATE]}
                    userPermission={this.props.userDetail.permissions}
                >
                    <div
                        className="btndeletelistuseranswer"
                        onClick={() => this.props.handleRemoveRelatedAnswer(answer)}
                    >
                        <FontAwesomeIcon
                            className="border-2 border-secondary-text rounded-full w-2.5 h-2.5 p-0.5 cursor-pointer transition-opacity duration-200 hover:opacity-70 select-none"
                            icon={faClose}
                        />
                    </div>
                </CheckPermissionComponent>
            </div>
        ))
    }

    handleScrollAnswerListToBottom = () => {
        this.automaticMessageCardRef.current.scrollTop = this.automaticMessageCardRef.current.scrollHeight
        this.answerListRef.current.scrollTop = this.answerListRef.current.scrollHeight
    }

    handleKMSChange = (option, { action }) => {
        this.props.setDefaultState({
            data: {
                ...this.props.data,
                kms: option
            }
        })
    }

    handleKMSInputChange = (value) => {
        this.getChatBotKMS(1, 50, value)
    }

    handleUpdateQNA = async e => {
        e.preventDefault()

        this.props.showLoader(true)

        await this.props.setErrorAnswers([])

        if (!this.validateData()) {
            this.props.showLoader(false)
            return
        }

        const data = this.props.data
        let body = {
            id: this.props.qnaId,
            bot_message: data.automaticMessage,
            question: data.qnaName,
            first_message: data.isFirstMessage,
            opsi_back: data.backOption,
            is_related_to_solution: data.isRelatedToSolution,
            kms_id: data.kms?.value || 0,
            answer_related: [...data.relatedAnswers, ...data.removedRelatedAnswers],
            answer_id: data.answerList,
        }

        body = this.getDisabledBody(body)

        API_SETTINGS.postChatBotQNA(body, this.props.token)
            .then(async () => {
                this.props.showSuccessAlert()

                await this.getData()

                this.updateQuestionList(body.id)

                this.props.clearRemovedRelatedAnswers()

                this.setIsFormDirty()
            })
            .catch(err => this.props.showErrorAlert(getErrorMessage(err)))
            .finally(() => this.props.showLoader(false))
    }

    handleInsertQNA = async e => {
        e.preventDefault()

        this.props.showLoader(true)

        await this.props.setErrorAnswers([])

        if (!this.validateData()) {
            this.props.showLoader(false)
            return
        }

        const data = this.props.data
        let body = {
            id: !this.props.isCreate ? this.props.qnaId : 0,
            bot_message: data.automaticMessage,
            question: data.qnaName,
            first_message: data.isFirstMessage,
            opsi_back: data.backOption,
            is_related_to_solution: data.isRelatedToSolution,
            kms_id: data.kms?.value || 0,
            answer_related: [...data.relatedAnswers, ...data.removedRelatedAnswers],
            answer_id: data.answerList,
        }

        body = this.getDisabledBody(body)

        API_SETTINGS.postChatBotQNA(body, this.props.token)
            .then(async (res) => {
                const qnaId = getContent(res)

                this.props.showSuccessAlert()

                this.props.clearRemovedRelatedAnswers()

                this.setState({
                    isFormDirty: false
                })

                await this.refetchLastPageOfQuestions()

                this.props.history.push(`?qnaid=${qnaId}`)
            })
            .catch(err => this.props.showErrorAlert(getErrorMessage(err)))
            .finally(() => this.props.showLoader(false))
    }

    refetchLastPageOfQuestions = async () => {
        await this.props.initiateGetListChatBotQuestion(this.props.qna.keyword)

        if (this.props.qna.page === this.props.qna.totalPage) {
            await this.props.getListChatBotQuestion(this.props.qna.page, this.props.qna.keyword, true)
        }
    }

    updateQuestionList(id) {
        return API_SETTINGS.getDetailChatBotQNAById(id, this.props.token)
            .then((res) => {
                const content = getContent(res)

                const questionList = this.props.qna.questionList
                const i = questionList.findIndex(qna => qna.id === id)

                if (i === -1) {
                    return
                }

                questionList[i].question = content.question
                questionList[i].updated_at = content.updated_at

                this.props.setQNA({
                    ...this.props.qna,
                    questionList: [...questionList]
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    validateData = () => {
        const data = this.props.data

        const qnaNameError = this.validateQNAName(data.qnaName)
        if (qnaNameError) {
            this.props.showErrorAlert(qnaNameError)

            return false
        }

        const automaticMessageError = this.props.validateAutomaticMessage(data.automaticMessage)
        if (automaticMessageError) {
            this.props.showErrorAlert(automaticMessageError)

            return false
        }

        const errorAnswers = this.props.validateAnswers(data.answerList)

        if (errorAnswers.length > 0) {
            const firstError = errorAnswers[0]

            this.props.showErrorAlert('List Jawaban tidak valid')

            this.props.setErrorAnswers(errorAnswers, () => {
                const ref = this.answerListRef.current
                const offset = ref.children[firstError.index].offsetTop

                ref.scrollTop = offset
            })

            return false
        }

        return true
    }

    validateQNAName = (qnaName = '') => {
        if (qnaName.length < 3) {
            return 'Minimal panjang karakter Judul Template 3 karakter'
        }

        if (qnaName.length > 100) {
            return 'Maksimal panjang karakter Judul Template 100 karakter'
        }

        return ''
    }

    resetForm = async () => {
        const content = this.state.currentChatBotMessage

        const relatedAnswers = content.answer_related?.map(answer => ({
            id: answer.id,
            answer: answer.answer,
            action: answer.action
        }))

        const answers = content.answer_id?.map(answer => ({
            key: uuidv4(),
            id: answer.id,
            answer: answer.answer,
            url_link: answer.url_link,
            action: answer.action,
            withLink: answer.url_link !== ''
        }))

        this.getChatBotRelatedAnswers()

        await this.props.clearRemovedRelatedAnswers()

        this.props.setDefaultState({
            data: {
                ...this.props.data,
                automaticMessage: content.bot_message,
                qnaName: content.question,
                isFirstMessage: content.first_message,
                backOption: content.opsi_back,
                isRelatedToSolution: content.is_related_to_solution,
                kmsId: content.kms_id,
                relatedAnswers: relatedAnswers || [],
                answerList: answers || []
            },
        }, () => this.props.closeResetFormAlert())
    }

    render() {
        if (!this.props.isCreate) {
            if (!this.props.isQNAFound) {
                return <Redirect to={`${ROUTER_CONSTANT.SETTINGS_CHATBOT_FLOW}?template=${TEMPLATE_GREETING}`} />
            }
        }

        if (this.props.isCreate && !CheckPermissionApi(SETTING_CHATBOT_FLOW_INSERT, this.props.userDetail.permissions)) {
            return <Redirect to={`${ROUTER_CONSTANT.SETTINGS_CHATBOT_FLOW}?template=${TEMPLATE_GREETING}`} />
        }

        return (
            <>
                <RouterPrompt
                    when={this.state.isFormDirty}
                    history={this.props.history}
                />
                <form className="chatbot-flow-form flex flex-col w-2/4 h-full p-6 bg-white shadow-md rounded-md border border-gray-300 overflow-auto" onSubmit={this.props.isCreate ? this.handleInsertQNA : this.handleUpdateQNA}>
                    <div className="template-name mb-5">
                        <label className="inline-block mb-2 font-medium" htmlFor="tsltitlemessage">Judul Template Tanya & Jawab</label>
                        <input
                            className="form-control"
                            type="text"
                            id="tsltitlemessage"
                            placeholder="Tulis Judul Tanya & Jawab"
                            name="qnaName"
                            value={this.props.data.qnaName}
                            onChange={this.props.handleChange}
                            maxLength={100}
                        />
                    </div>
                    <div className="flex gap-6 mb-8" style={{ height: '75%' }}>
                        <div className="card-form w-full shadow-md rounded-lg border border-gray-300 bg-white">
                            <div className="card-title text-center p-6 text-xl text-white bg-olddarkblue font-bold rounded-t-lg">Pesan Pengguna</div>
                            <div className="card-body flex flex-col p-6 h-full" style={{ maxHeight: '400px' }}>
                                <label className="inline-block mb-2 font-medium" htmlFor="ddsinputlistanswer">Terhubung Dengan Jawaban</label>
                                <CheckPermissionComponent
                                    permissionConstant={this.props.isCreate ? [SETTING_CHATBOT_FLOW_INSERT] : [SETTING_CHATBOT_FLOW_UPDATE]}
                                    userPermission={this.props.userDetail.permissions}
                                >
                                    <Select
                                        id="ddslistanswer"
                                        inputId="ddsinputlistanswer"
                                        className="w-full mb-3"
                                        placeholder="Pilih Jawaban"
                                        options={
                                            [this.props.defaultRelatedAnswer, ...this.props.relatedAnswerOptions]
                                        }
                                        value={this.props.defaultRelatedAnswer}
                                        onChange={(option) => this.props.handleRelatedAnswerChange(option, this.relatedAnswerListRef)}
                                        onInputChange={(value) => this.props.handleSearchRelatedAnswer(value, this.chatBotType, this.props.qnaId)}
                                    />
                                </CheckPermissionComponent>
                                <div className="selected-answers h-full max-h-full overflow-auto" ref={this.relatedAnswerListRef}>
                                    {this.mapRelatedAnswers()}
                                </div>
                            </div>
                        </div>
                        <div className="card-form flex flex-col w-full shadow-md rounded-lg border border-gray-300 bg-white">
                            <div className="card-title text-center p-6 text-xl text-white bg-olddarkblue font-bold rounded-t-lg">Pesan Otomatis</div>
                            <div className="card-body h-full max-h-full px-6 py-6 overflow-auto" ref={this.automaticMessageCardRef}>
                                <div className="checkbox flex items-center justify-between mb-8">
                                    <label className="block w-full select-none font-medium" htmlFor="tglgreetingmessage">Menjadi Pesan Pertama</label>
                                    <ToggleSwitch
                                        id="tglgreetingmessage"
                                        name="isFirstMessage"
                                        onChange={this.props.handleChecked}
                                        checked={this.props.data.isFirstMessage}
                                        disabled={this.state.disabledFields.isFirstMessage}
                                    />
                                </div>
                                <div className="checkbox flex items-center justify-between mb-8">
                                    <label className="block w-full select-none font-medium" htmlFor="tgloptionback">Opsi Tombol Kembali</label>
                                    <ToggleSwitch
                                        id="tgloptionback"
                                        name="backOption"
                                        onChange={this.props.handleChecked}
                                        checked={this.props.data.backOption}
                                        disabled={this.state.disabledFields.backOption}
                                    />
                                </div>
                                <div className="checkbox flex items-center justify-between mb-8">
                                    <label className="block w-full select-none font-medium" htmlFor="tglsolutionmessage">Menjadi Pesan Solusi</label>
                                    <ToggleSwitch
                                        id="tglsolutionmessage"
                                        name="isRelatedToSolution"
                                        onChange={this.props.handleChecked}
                                        checked={this.props.data.isRelatedToSolution}
                                        disabled={this.state.disabledFields.isRelatedToSolution}
                                    />
                                </div>
                                <div className="select mb-4">
                                    <label className="block mb-1 font-medium" htmlFor="ddsinputkmslist">Pesan Terhubung Dengan KMS</label>
                                    <Select
                                        id="ddskmslist"
                                        inputId="ddsinputkmslist"
                                        className="w-full"
                                        placeholder="Pilih Daftar KMS"
                                        options={this.state.kmsOptions}
                                        value={this.props.data.kms}
                                        onChange={this.handleKMSChange}
                                        onInputChange={this.handleKMSInputChange}
                                        isDisabled={this.state.disabledFields.kmsId}
                                        isClearable
                                    />
                                </div>
                                <div className="textarea mb-4">
                                    <label className="block mb-1 font-medium" htmlFor="tmlbotmessage">Pesan Otomatis</label>
                                    <textarea
                                        className="form-control resize-none"
                                        id="tmlbotmessage"
                                        name="automaticMessage"
                                        cols="30"
                                        rows="5"
                                        placeholder="Tulis Pesan Otomatis"
                                        value={this.props.data.automaticMessage}
                                        onChange={this.props.handleChange}
                                    ></textarea>
                                </div>
                                <div className="flex-1 flex flex-col mb-1">
                                    <label className="block mb-1 font-medium">List Jawaban</label>
                                    <div className="mb-3 overflow-auto relative" ref={this.answerListRef} style={{ maxHeight: '300px' }}>
                                        {this.mapAnswers()}
                                    </div>
                                    <CheckPermissionComponent
                                        permissionConstant={
                                            this.props.isCreate
                                                ? [SETTING_CHATBOT_FLOW_INSERT]
                                                : [SETTING_CHATBOT_FLOW_UPDATE]
                                        }
                                        userPermission={this.props.userDetail.permissions}
                                    >
                                        <ButtonBorderDarkBlue
                                            id="btnaddanswer"
                                            className="w-full"
                                            onClick={() => this.props.handleAddAnswer(this.handleScrollAnswerListToBottom)}
                                            type="button"
                                        >
                                            <FontAwesomeIcon size="sm" className="mr-1" icon={faPlusCircle} />
                                            <span>Tambah List Jawaban</span>
                                        </ButtonBorderDarkBlue>
                                    </CheckPermissionComponent>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="button mt-auto flex items-end justify-end">
                        <CheckPermissionComponent permissionConstant={[SETTING_CHATBOT_FLOW_UPDATE]} userPermission={this.props.userDetail.permissions}>
                            {
                                !this.props.isCreate && (
                                    <ButtonBorderDarkBlue
                                        type="button"
                                        className="mr-2"
                                        id="btncancel"
                                        onClick={() => this.props.showResetFormAlert(this.resetForm)}>Batal</ButtonBorderDarkBlue>
                                )
                            }
                        </CheckPermissionComponent>
                        <CheckPermissionComponent
                            permissionConstant={
                                this.props.isCreate
                                    ? [SETTING_CHATBOT_FLOW_INSERT]
                                    : [SETTING_CHATBOT_FLOW_UPDATE]
                            }
                            userPermission={this.props.userDetail.permissions}
                        >
                            <ButtonDarkBlue id="btnsave">Simpan</ButtonDarkBlue>
                        </CheckPermissionComponent>
                    </div>
                </form>
            </>
        )
    }
}

class ChatBotPreview extends Component {
    mapMessages = () => {
        if (this.props.previewMessages.length === 0) {
            return (
                <div className="flex flex-col justify-center items-center h-full">
                    <img className="mb-3" src={NoChatPreviewImg} alt="Empty" />
                    <strong className="text-xl mb-2 text-center" style={{ color: '#1D1D1D' }}>Tidak Ada Tampilan Pesan Ola</strong>
                    <span className="text-center" style={{ color: '#818181' }}>Anda belum membuat pesan otomatis</span>
                </div>
            )
        }

        return this.props.previewMessages.map(message => {
            if (message.isBot) {
                return (
                    <div key={message.key} className="chat chat-bot flex items-start justify-end mb-3">
                        <div className="chat-bubble border p-3 mr-2 rounded-2xl rounded-tr-none" style={{ backgroundColor: '#E6EEF5', borderColor: '#9CBBD9' }}>
                            <div className="username font-bold mb-2 text-nexcare">Pesan Otomatis</div>
                            <p className="text font-medium">{message.message}</p>
                            <div className="answers mt-3">
                                {this.mapAnswers(message.answers, message.backOption)}
                            </div>
                            <div className="mt-2 flex items-center justify-end">
                                <IconDoubleCheck />
                                <div className="text-sm text-gray-400 ml-1">13:20 PM</div>
                            </div>
                        </div>
                        <div className="flex justify-center items-center rounded-full text-white font-bold bg-olddarkblue" style={{
                            minWidth: '2rem', minHeight: '2rem'
                        }}>N</div>
                    </div>
                )
            }

            return (
                <div key={message.key} className="chat chat-user flex items-start justify-start mb-3">
                    <div className="flex justify-center items-center w-8 h-8 rounded-full text-white font-bold" style={{ backgroundColor: '#0EA8FF' }}>U</div>
                    <div className="chat-bubble border border-gray-300 p-3 ml-2 rounded-2xl rounded-tl-none">
                        <div className="username font-bold mb-2" style={{ color: '#2266AA' }}>Pengguna</div>
                        <p className="text font-medium">{message.message}</p>
                        <div className="w-max ml-auto mt-2 text-sm text-gray-400">13:20 PM</div>
                    </div>
                </div>
            )
        })
    }

    mapAnswers = (answers = [], backOption = false) => {
        if (!answers) {
            return
        }

        if (backOption) {
            answers = [...answers, {
                key: uuidv4(),
                answer: 'Kembali'
            }]
        }

        return answers.map(answer => (
            <div key={answer.key} className="answer text-center border-2 border-nexcare rounded-sm text-nexcare mb-2">{answer.answer}</div>
        ))
    }

    render() {
        return (
            <div className="chatbot-flow-preview w-1/4 h-full">
                <div className="card flex flex-col border shadow-md border-gray-300 rounded-lg h-full overflow-hidden">
                    <div className="card-title relative font-bold bg-olddarkblue text-white text-2xl text-center p-6 rounded-t-lg overflow-hidden">
                        <img className="absolute bottom-0 left-2 max-w-none pointer-events-none" src={chatBotOlaImage} alt="Chat Bot Ola" style={{ width: '90px' }} />
                        <span className="relative z-10">OLA</span>
                    </div>
                    <div className="card-body p-6 bg-white h-full max-h-full overflow-auto">
                        {this.mapMessages()}
                    </div>
                </div>
            </div>
        )
    }
}